import { report360 } from '@/locales/de-DE/report360';
export const assets = {
list: {
zonesAction: "Zonen",
zonesTitle_one: "Zonen f\u00fcr {{count}} Anlage",
zonesTitle_other: "Zonen f\u00fcr {{count}} Anlagen",
zonesAdd: "Zonen hinzuf\u00fcgen",
zonesRemove: "Entfernen",
zonesSaved_one: "Zonen an {{count}} Anlage gespeichert",
zonesSaved_other: "Zonen an {{count}} Anlagen gespeichert",
zonesFailedTitle: "Zonen konnten nicht gespeichert werden",
zonesFailedBody: "Einige Anlagen wurden eventuell nicht ge\u00e4ndert. Pr\u00fcfen Sie die Verbindung und versuchen Sie es erneut.",
  showMeHow: "Zeig mir, wie",
title: "Anlagen",
viewList: "Listenansicht",
viewCards: "Kachelansicht",
viewGraph: "Netzwerkansicht — Heatmap nach Zustand",
viewMap: "Kartenansicht",
viewLabel: "Ansicht",
subtitleOwned_one: "{{count}} Anlage",
subtitleOwned_other: "{{count}} Anlagen",
subtitleOwnedOfLimit_one: "{{owned}} von {{count}} Anlage",
subtitleOwnedOfLimit_other: "{{owned}} von {{count}} Anlagen",
subtitleSharedEmpty: "Mit Ihnen geteilte Berichte erscheinen hier",
subtitleShared_one: "{{count}} Anlage mit Ihnen geteilt",
subtitleShared_other: "{{count}} Anlagen mit Ihnen geteilt",
shareWithContactSubtitle: "Eine Anlage mit {{name}} teilen",
shareWithContactSubtitleNoName: "Eine Anlage mit diesem Kontakt teilen",
searchPlaceholder: "Suchen",
searchA11y: "Anlagen suchen",
refine: "Filtern",
refineA11y: "Anlagenliste filtern",
tools: "Werkzeuge",
addAsset: "Anlage hinzufügen",
trySample: "Beispiel testen",
trySampleError: "Beispiel konnte nicht eingerichtet werden. Legen Sie stattdessen eine Anlage an.",
addAssetA11y: "Neue Anlage hinzufügen",
refineSheetTitle: "Anlagen filtern",
scope: "Bereich",
groupBy: "Gruppieren nach",
filters: "Filter",
pickerType: "Anlagentyp",
pickerSort: "Sortieren nach",
pickerHealth: "Gesundheitswert",
pickerRelationship: "Beziehungstyp",
toolsMenuTitle: "Werkzeuge",
selectAssets: "Anlagen auswählen",
scanQr: "QR scannen",
exportAllCsv: "Alle exportieren (CSV)",
exportAllA11y: "Alle sichtbaren Anlagen als CSV herunterladen",
emptyNoAssetsTitle: "Noch keine Anlagen",
emptyNoAssetsSub: "Fügen Sie Ihre erste Anlage hinzu, um dafür Inspektionen und Aufträge zu starten.",
emptyContractorSub: "Anlagen, die Ihre Kunden mit Ihnen teilen, erscheinen hier; zugewiesene Aufträge finden Sie unter Arbeit. Sie können auch eigene registrieren.",
emptySharedNoneTitle: "Noch keine geteilten Anlagen",
emptySharedNoneSub: "Anlagen aus mit Ihnen geteilten Inspektionen erscheinen hier. Öffnen Sie einen geteilten Bericht über Aktivität oder Ihren E-Mail-Link.",
emptyScopeTitle: "Keine Anlagen in {{scope}}",
emptyScopeSub: "Ändern Sie den Bereichsfilter oder fügen Sie diesem Team Anlagen hinzu.",
emptyFilterTitle: "Keine passenden Anlagen",
emptyFilterSub: "Andere Suchbegriffe versuchen oder Filter zurücksetzen.",
clearFilters: "Filter zurücksetzen",
webViewerEmptyTitle: "Keine Zeile ausgewählt",
webViewerEmptySub: "Wählen Sie eine Anlage in der Liste, um den Viewer unten zu öffnen.",
workspaceInsightSummary: "{{total}} in der Ansicht · {{poor}} schlechte Gesundheit · {{watch}} beobachten · {{good}} gut · {{unscored}} noch nicht bewertet",
operationalInsight: {
insightPanelTitle: "Bestandsanalyse",
insightSourceExisting: "Bestehende Zustandsbänder der Anlagen",
summaryLine: "{{total}} Anlagen · {{poor}} schlechter Zustand · {{watch}} Beobachtung · {{good}} gut · {{unscored}} ohne Bewertung",
poorExplanation_one: "{{count}} Anlage hat einen Zustandswert von 40 oder weniger.",
poorExplanation_other: "{{count}} Anlagen haben einen Zustandswert von 40 oder weniger.",
poorRecommended: "Priorisieren Sie Prüfungen, Aufträge und Dokumente, die diese Werte senken.",
poorCta: "Nach schlechtem Zustand filtern",
watchExplanation_one: "{{count}} Anlage befindet sich im Beobachtungsbereich (41–70).",
watchExplanation_other: "{{count}} Anlagen befinden sich im Beobachtungsbereich (41–70).",
watchRecommended: "Planen Sie Prüfungen oder Maßnahmen, bevor sich der Zustand verschlechtert.",
watchCta: "Nach Beobachtungsbereich filtern",
unscoredExplanation_one: "{{count}} Anlage hat noch keinen Zustandswert.",
unscoredExplanation_other: "{{count}} Anlagen haben noch keinen Zustandswert.",
unscoredRecommended: "Vervollständigen Sie die Profildaten und führen Sie Prüfungen durch, damit eine Bewertung möglich ist.",
unscoredCta: "Filter öffnen",
balancedExplanation: "In dieser Ansicht befindet sich keine Anlage in schlechtem Zustand oder im Beobachtungsbereich.",
balancedRecommended: "Halten Sie Prüfungen und Aufträge aktuell, um die Werte stabil zu halten.",
refineCta: "Liste filtern",
exportCsvLabel: "Sichtbare Anlagen exportieren (CSV)",
},
cancel: "Abbrechen",
selected_one: "{{count}} ausgewählt",
selected_other: "{{count}} ausgewählt",
clearVisible: "Sichtbare abwählen",
allVisible: "Alle sichtbaren",
exportCsv: "CSV exportieren",
bulkExportA11y: "Ausgewählte Anlagen als CSV exportieren",
bulkSelectAllA11y: "Alle sichtbaren Anlagen auswählen",
bulkDeselectAllA11y: "Auswahl aller sichtbaren Anlagen aufheben",
printLabels: "Etiketten drucken",
assignTeam: "Team zuweisen",
assignToTeam: "Team zuweisen",
personal: "Persönlich",
unknownTeam: "Unbekanntes Team",
qrPrintTitle: "Etiketten für ausgewählte Anlagen drucken",
exportNoSelectionTitle: "Keine Anlagen ausgewählt",
exportNoSelectionBody: "Wählen Sie mindestens eine sichtbare Anlage zum Exportieren.",
exportCopiedTitle: "Export kopiert",
exportCopiedBody_one: "{{count}} Anlagenzeile als CSV kopiert.",
exportCopiedBody_other: "{{count}} Anlagenzeilen als CSV kopiert.",
exportErrorTitle: "Fehler",
exportErrorBody: "Anlagen konnten nicht aktualisiert werden.",
typeChip: "Typ",
sortChip: "Sortierung",
healthChip: "Gesundheit",
relationshipChip: "Beziehung",
typeAll: "Alle Typen",
typeCar: "Fahrzeug",
typeProperty: "Ort",
typeEquipment: "Ausrüstung",
typeOther: "Sonstiges",
kindAll: "Alle",
kindPlaces: "Orte",
kindEquipment: "Ausrüstung",
kindVehicles: "Fahrzeuge",
sortNewest: "Neueste zuerst",
sortOldest: "Älteste zuerst",
sortNameAsc: "Name A–Z",
sortNameDesc: "Name Z–A",
sortLastInspected: "Zuletzt inspiziert",
sortMostInspections: "Meiste Inspektionen",
healthAny: "Beliebiger Gesundheitswert",
healthLt80: "Wert unter 80",
healthLt60: "Wert unter 60",
relationshipAll: "Beliebige Beziehung",
groupType: "Typ",
groupTeam: "Team",
viewActivity: "Aktivität anzeigen",
signalNoInspection: "Keine Inspektion",
signalNoData: "Keine Daten",
loadingMore: "Weitere werden geladen…",
endOfList_one: "{{count}} Anlage — das ist alles",
endOfList_other: "{{count}} Anlagen — das ist alles",
endOfListInView_one: "{{count}} Anlage in dieser Ansicht",
endOfListInView_other: "{{count}} Anlagen in dieser Ansicht",
signalScore: "Wert {{score}}",
signalNoHealthScore: "Kein Gesundheitswert",
signalRisk: "Risiko {{level}}",
signalNoRisk: "Kein Risikowert",
signalNotScored: "Nicht bewertet",
healthGood: "Gut",
healthWatch: "Beobachten",
healthPoor: "Schlecht",
riskLow: "Niedrig",
riskMedium: "Mittel",
riskHigh: "Hoch",
riskExtreme: "Sehr hoch",
csvHeaderAsset: "Anlage",
csvHeaderType: "Typ",
csvHeaderHealthStatus: "Gesundheitsstatus",
csvHeaderHealthScore: "Gesundheitswert",
csvHeaderRisk: "Risiko",
csvHeaderRiskScore: "Risikowert",
csvHeaderOpenJobs: "Offene Aufträge",
csvHeaderOverdueJobs: "Überfällige Aufträge",
csvHeaderLastInspection: "Letzte Inspektion",
csvHeaderCreated: "Erstellt",
csvExportName: "Name",
csvExportType: "Typ",
csvExportTeam: "Team",
csvExportCreated: "Erstellt",
csvExportUpdated: "Aktualisiert",
insightStripTitle: "Gesundheit",
healthStatusHeadline: "{{critical}} kritisch · {{warning}} unter Beobachtung",
healthStatusSecondary: "{{good}} in gutem Zustand · {{unscored}} ohne Bewertung",
queueAttention: "Handlungsbedarf",
queueAll: "Alle Anlagen",
queueShared: "Geteilt",
queueTablistA11y: "Anlagenlistenansicht",
inspectPriority: "Dringendste Anlage prüfen",
inspectPriorityA11y: "Wichtigste Anlage mit Handlungsbedarf öffnen",
advancedFiltersTitle: "Erweiterte Filter & Sortierung",
advancedFiltersSummary_one: "{{count}} aktive Einschränkung",
advancedFiltersSummary_other: "{{count}} aktive Einschränkungen",
advancedFiltersSummaryEmpty: "Typ, Zustand, Sortierung, Gruppierung, Bereich",
advancedFiltersExpand: "Filter anzeigen",
advancedFiltersCollapse: "Filter ausblenden",
emptyAttentionClearTitle: "Kein Handlungsbedarf",
emptyAttentionClearSub: "Alle Anlagen in diesem Bereich sind in gutem Zustand oder ohne Bewertung.",
emptyAttentionShowAll: "Alle Anlagen anzeigen",
emptySharedTitle: "Nichts mit Ihnen geteilt",
emptySharedSub: "Anlagen, die ein anderer Arbeitsbereich mit Ihnen teilt, werden hier angezeigt.",
moreActions: "Weitere Aktionen",
queueRetired: "Ausgemustert",
},
contacts: {
emptyTitle: "Noch keine Kontakte verknüpft",
emptyDescription: "Verknüpfen Sie Eigentümer, Mieter, Auftragnehmer oder Verwalter — und teilen Sie den Zugriff gleich mit.",
emptyWithRecipients_one: "{{count}} Person hat einen Bericht zu dieser Anlage erhalten, ist aber noch nicht verknüpft. Verknüpfen Sie sie, damit die Beziehung an der Anlage bleibt.",
emptyWithRecipients_other: "{{count}} Personen haben Berichte zu dieser Anlage erhalten, sind aber noch nicht verknüpft. Verknüpfen Sie sie, damit die Beziehung an der Anlage bleibt.",
linkContact: "Kontakt verknüpfen",
reportRecipients: "Berichtsempfänger",
recipientCount_one: "{{count}} Empfänger",
recipientCount_other: "{{count}} Empfänger",
},
shared: {
  contactRelationship: {
    other: "Sonstiges",
    manager: "Verwalter",
    occupant: "Bewohner",
    site_contact: "Ansprechpartner vor Ort",
    reviewer: "Prüft die Arbeit",
    approver: "Gibt Arbeit frei",
    observer: "Wird informiert",
    supplier: "Lieferant",
    contractor: "Auftragnehmer",
    client: "Kunde",
    landlord: "Vermieter",
    tenant: "Mieter",
    owner: "Eigentümer",
    recipient: "Erhält Berichte",
    requester: "Meldet Probleme",
    assignee: "Führt die Arbeit aus",
  },
  disposalMethod: {
    other: "Sonstiges",
    donated: "Gespendet",
    transferred: "Übertragen",
    returned: "An den Vermieter zurückgegeben",
    recycled: "Recycelt",
    scrapped: "Verschrottet",
    sold: "Verkauft",
  },
  retirementReason: {
    other: "Sonstiges",
    lost: "Verloren oder gestohlen",
    replaced: "Ersetzt",
    decommissioned: "Außer Betrieb genommen",
    disposed: "Entsorgt",
    sold: "Verkauft",
  },
  decommissionReason: {
    other: "Sonstiges",
    relocated: "Umgezogen",
    seasonal: "Saisonale Stilllegung",
    replaced: "Ersetzt",
    fault: "Defekt",
    end_of_life: "Ende der Nutzungsdauer",
  },
  standing: {
    active: "Aktiv",
    retired: "Ausgemustert",
    archived: "Archiviert",
    decommissioned: "Außer Betrieb",
    planned: "Noch nicht in Betrieb",
    in_service: "In Betrieb",
  },
  complianceTag: {
    warranty_active: "Garantie aktiv",
    insurance_required: "Versicherung erforderlich",
    ppe: "Schutzausrüstung",
    pressure_system: "Druckanlage",
    lifting_equipment: "Hebezeuge",
    vehicle_roadworthy: "Verkehrstüchtig",
    energy_performance: "Energieeffizienz (Energieausweis)",
    water_hygiene: "Wasserhygiene",
    gas_safety: "Gassicherheit",
    electrical_safety: "Elektrische Sicherheit",
    fire_safety: "Brandschutz",
  },
  operatingContext: {
    operational: "Laufender Betrieb",
    storage: "Lagerung",
    shared_use: "Gemeinsame Nutzung",
    staff_only: "Nur Personal",
    customer_facing: "Von Kunden genutzt",
  },
  lifecycle: {
    decommissioned: "Außer Betrieb",
    under_renovation: "In Renovierung",
    partially_operational: "Teilweise in Betrieb",
    operational: "In Betrieb",
    handover: "In Übergabe",
    partially_developed: "Teilweise fertig",
    in_development: "Im Bau",
    planned: "Geplant",
  },
  otherDomain: {
    other: "Sonstiges",
    miscellaneous: "Verschiedenes",
    storage: "Lagerung",
    fixture: "Einbau",
    inventory: "Bestand",
    signage: "Beschilderung",
    it: "IT-Geräte",
    furniture: "Möbel",
  },
  installation: {
    vehicle_mounted: "Fahrzeugmontiert",
    portable: "Tragbar",
    fixed: "Fest installiert",
  },
  powerSource: {
    pneumatic: "Druckluft",
    hydraulic: "Hydraulisch",
    manual: "Manuell",
    gas: "Gasbetrieben",
    petrol: "Benzin",
    diesel: "Dieselbetrieben",
    battery: "Akku",
    electric: "Elektrisch",
  },
  equipmentClass: {
    other: "Sonstiges",
    kitchen_equipment: "Küchengeräte",
    appliance: "Gerät",
    electrical_distribution: "Stromverteilung",
    fire_system: "Brandschutzanlage",
    safety_equipment: "Sicherheitsausrüstung",
    cleaning_machine: "Reinigungsmaschine",
    machine: "Maschine",
    power_tool: "Elektrowerkzeug",
    lift: "Aufzug",
    compressor: "Kompressor",
    forklift: "Gabelstapler",
    pump: "Pumpe",
    generator: "Stromerzeuger",
    boiler: "Heizkessel",
    hvac: "Heizung und Klima",
  },
  vehicleUsage: {
    plant_support: "Maschinenunterstützung",
    site_use: "Einsatz vor Ort",
    passenger_transport: "Personenbeförderung",
    delivery: "Lieferung",
    fleet: "Flotte",
    personal: "Privat",
  },
  vehicleFuel: {
    other: "Sonstiges",
    lpg: "Autogas",
    electric: "Elektrisch",
    hybrid: "Hybridantrieb",
    diesel: "Dieselkraftstoff",
    petrol: "Benzin",
  },
  vehicleClass: {
    other: "Sonstiges",
    plant_vehicle: "Baumaschine",
    bus: "Omnibus",
    motorcycle: "Motorrad",
    trailer: "Anhänger",
    truck: "Lkw",
    van: "Transporter",
    car: "Pkw",
  },
  occupancy: {
    new_build: "Neubau",
    under_renovation: "In Renovierung",
    partially_occupied: "Teilweise bewohnt",
    vacant: "Leerstehend",
    occupied: "Bewohnt",
  },
  propertySubtype: {
    other: "Sonstiges",
    depot: "Betriebshof",
    plant: "Werk",
    yard: "Hof",
    workshop: "Werkstatt",
    factory: "Fabrik",
    warehouse: "Lager",
    mixed_use: "Gemischte Nutzung",
    education: "Schule oder Hochschule",
    healthcare: "Gesundheitswesen",
    hospitality: "Hotel oder Restaurant",
    retail: "Einzelhandel",
    office: "Büro",
    holiday_rental: "Ferienunterkunft",
    student_accommodation: "Studentenunterkunft",
    studio: "Einzimmerwohnung",
    townhouse: "Reihenhaus",
    flat: "Wohnung",
    apartment: "Etagenwohnung",
    house: "Haus",
  },
assetType: {
car: "Fahrzeug",
property: "Ort",
equipment: "Ausrüstung",
other: "Sonstiges",
},
externalIdType: {
vin: "Fahrgestellnummer",
serial: "Seriennummer",
registration: "Kennzeichen",
barcode: "Barcode",
custom: "Benutzerdefinierte ID",
},
documentType: {
certificate: "Zertifikat",
warranty: "Garantie",
compliance: "Konformität",
general: "Allgemein",
},
criticality: {
low: "Niedrig",
medium: "Mittel",
high: "Hoch",
critical: "Kritisch",
},
mobility: {
fixed: "Ortsfest",
movable: "Versetzbar",
mobile: "Mobil",
},
propertyFamily: {
residential: "Wohnen",
commercial: "Gewerbe",
industrial: "Industrie",
},
furnishedStatus: {
unfurnished: "Unmöbliert",
part_furnished: "Teilmöbliert",
fully_furnished: "Vollmöbliert",
},
propertySystem: {
hvac: "Heizung, Lüftung, Klima",
electrical: "Elektrik",
plumbing: "Sanitär",
fire_alarm: "Brandmeldeanlage",
sprinklers: "Sprinkleranlage",
security_alarm: "Alarmanlage",
access_control: "Zutrittskontrolle",
cctv: "Videoüberwachung",
lift: "Aufzug",
solar: "Solaranlage",
},
vehicleTransmission: {
manual: "Schaltgetriebe",
automatic: "Automatik",
semi_automatic: "Halbautomatik",
},
vehicleConditionFlag: {
road_legal: "Straßenzugelassen",
insured: "Versichert",
under_warranty: "Unter Garantie",
service_contract: "Wartungsvertrag",
high_mileage: "Hohe Laufleistung",
off_road_use: "Geländeeinsatz",
},
equipmentConditionFlag: {
service_contract: "Wartungsvertrag",
under_warranty: "Unter Garantie",
calibration_required: "Kalibrierung erforderlich",
inspection_required: "Inspektion erforderlich",
safety_critical: "Sicherheitskritisch",
},
equipmentCapacityUnit: {
litres: "Liter",
tonnes: "Tonnen",
other: "Sonstige",
},
equipmentSafetyClass: {
general: "Allgemein",
safety_critical: "Sicherheitskritisch",
lifting: "Hebezeug",
pressure: "Druckgerät",
electrical: "Elektrisch",
fire_safety: "Brandschutz",
},
equipmentOperatingEnvironment: {
indoor: "Innen",
outdoor: "Außen",
mixed: "Gemischt",
wet_area: "Nassbereich",
dusty: "Staubig",
high_temperature: "Hohe Temperatur",
cold_environment: "Kalte Umgebung",
},
otherRiskTag: {
fragile: "Zerbrechlich",
high_value: "Hochwertig",
regulated: "Reguliert",
public_facing: "Öffentlich zugänglich",
portable: "Tragbar",
safety_critical: "Sicherheitskritisch",
},
otherMiscKind: {
general: "Allgemein / nicht kategorisiert",
documentation: "Dokumentation & Unterlagen",
consumables: "Verbrauchsmaterial",
spare_parts: "Ersatzteile",
tooling: "Werkzeuge & Geräte",
display_marketing: "Präsentation & Marketing",
safety_supplies: "Sicherheitsbedarf",
mixed_stock: "Gemischter Bestand",
},
compliancePosture: {
clear: "In Ordnung",
watch: "Beobachten",
action: "Handlungsbedarf",
},
externalIdPlaceholder: {
vin: "z. B. 1HGBH41JXMN109186",
serial: "z. B. SN-2024-00123",
registration: "z. B. ABC 1234",
barcode: "z. B. Barcode oder QR-Wert scannen oder eingeben",
custom: "Eigene Referenz eingeben...",
},
},
documents: {
add: {
  editHint: "Ändern Sie Daten, Erinnerung, Titel oder Notizen und tippen Sie auf Dokument speichern. Die Datei bleibt unverändert.",
  editTitle: "Dokumentdetails bearbeiten",
pickTitle: "Dokument hinzufügen",
pickBody: "Wählen Sie, wie Sie das Dokument anhängen möchten.",
labels: {
  validMonths: "{{months}} Monate gültig",
  subtype: "Art des Dokuments",
referenceNumber: "Zertifikats- / Referenznummer",
documentType: "Dokumenttyp",
title: "Titel",
file: "Datei",
issueDate: "Ausstellungsdatum",
expiryDate: "Ablaufdatum",
reminderDays: "So viele Tage vor Ablauf erinnern",
notes: "Notizen",
validator: "Wer prüft und genehmigt es?",
validatorHint: "Die Person erhält eine Benachrichtigung und eine Aufgabe, bis sie es genehmigt oder ablehnt.",
validatorNoTeam: "Dieser Anlage ist noch kein verantwortliches Team zugeordnet, daher bleibt die Validierung bei Ihnen.",
validatorMe: "Ich",
validatorApprover: "Freigeber der Anlage",
},
placeholders: {
referenceNumber: "z. B. ABC123456 (optional)",
title: "z. B. Gasprüfzertifikat",
titleRenewed: "Erneuertes Zertifikat",
file: "Datei zum Hochladen auswählen",
issueDate: "JJJJ-MM-TT",
expiryDate: "JJJJ-MM-TT",
notes: "Private Notizen zu diesem Dokument",
},
a11y: {
saveDocument: "Dokument speichern",
},
actions: {
saving: "Wird gespeichert...",
submit: "Dokument speichern",
},
ai: {
title: "KI-Dokumentdetails",
suggestAction: "Details mit KI vorschlagen",
prompt: "Extrahiert Titel, Typ und Daten aus der hochgeladenen Datei, sobald Sie online sind.",
reviewHint: "Prüfen Sie die vorgeschlagenen Felder vor dem Speichern. Zertifikate erfordern weiterhin eine Validierung.",
applyAll: "Alle Vorschläge übernehmen",
providerName: "Anbieter / Aussteller",
assetIdentifier: "Anlagenkennung auf dem Dokument",
},
alerts: {
photoPermission: "Erlauben Sie den Zugriff auf die Fotobibliothek, um ein Dokumentbild auszuwählen.",
cameraPermission: "Erlauben Sie den Kamerazugriff, um ein Dokument zu erfassen.",
documentPicker: "Die Dateiauswahl konnte nicht geöffnet werden.",
assetNotFound: "Anlage nicht gefunden.",
titleRequired: "Geben Sie einen Dokumenttitel ein.",
fileRequired: "Wählen Sie eine Datei zum Hochladen aus.",
signInRequired: "Melden Sie sich erneut an, bevor Sie dieses Dokument speichern.",
saveFailed: "Dieses Dokument konnte nicht gespeichert werden.",
},
      energy: {
        scheme: "Ausweisart",
        schemeEPC: "EPC (Energieausweis)",
        schemeDEC: "DEC (Aushang)",
        rating: "Klasse",
        score: "Punktzahl",
        scorePlaceholder: "z. B. 68",
        isLet: "Das Gebäude ist vermietet",
        isLetHint: "Ein vermietetes Gebäude in England und Wales braucht mindestens E.",
        belowMinimum: "Unter E: Dieses Gebäude darf ohne Ausnahme nicht mit dieser Klasse vermietet werden.",
        ratingRequired: "Wählen Sie die Klasse aus dem Ausweis.",
      },
},
},
relationships: {
  alerts: {
    duplicateCheckFailedTitle: "Duplikate konnten nicht geprüft werden",
    markDistinct: "Nein, sie sind verschieden",
    markDuplicate: "Ja, als mögliches Duplikat markieren",
    duplicateFoundBody: "{{name}} ähnelt dieser Anlage. Ist es dieselbe?",
    duplicateFoundTitle: "Das könnte dieselbe Anlage sein",
    noDuplicatesBody: "Keine andere Anlage passt zu dieser.",
    noDuplicatesTitle: "Keine Duplikate gefunden",
    mergeFailedTitle: "Zusammenführen fehlgeschlagen",
    merge: "Zusammenführen",
    mergeBody: "Diese Anlage wird als zusammengeführt markiert. Ihr Verlauf bleibt erhalten.",
    mergeTitle: "Mit dem anderen Datensatz zusammenführen?",
    canonicalFailedTitle: "Hauptdatensatz konnte nicht festgelegt werden",
    removeFailedTitle: "Verknüpfung konnte nicht entfernt werden",
    remove: "Entfernen",
    cancel: "Abbrechen",
    removeBody: "Beide Anlagen bleiben erhalten. Nur die Verknüpfung wird entfernt.",
    removeTitle: "Diese Verknüpfung entfernen?",
    tryAgain: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    updateFailedTitle: "Verknüpfung konnte nicht gespeichert werden",
    addFailedTitle: "Verknüpfung konnte nicht hinzugefügt werden",
    selectAssetBody: "Suchen Sie die zu verknüpfende Anlage und tippen Sie darauf.",
    selectAssetTitle: "Anlage wählen",
  },
views: {
list: "Liste",
tree: "Baum",
map: "Karte",
},
refine: "Filtern",
refineA11y: "Karte filtern",
refineTitle: "Karte filtern",
refineShow: "Anzeigen",
refineRisk: "Risiko",
refineCriticality: "Kritikalität",
refineDepth: "Tiefe",
refineColour: "Einfärben nach",
refineLayout: "Anordnung",
filter: {
all: "Alle",
hierarchy: "Hierarchie",
dependency: "Abhängigkeit",
association: "Verknüpfung",
duplicate: "Duplikat",
inbound: "Eingehend",
outbound: "Ausgehend",
},
riskOnly: "Nur risikorelevant",
highlightCritical: "Kritische hervorheben",
hops_one: "{{count}} Ebene",
hops_other: "{{count}} Ebenen",
colour: {
combined: "Alle",
health: "Zustand",
type: "Typ",
risk: "Verbindungsart",
},
layout: {
auto: "Automatisch",
hierarchy: "Hierarchie",
force: "Netzwerk",
radial: "Radial",
grid: "Raster",
},
groups: {
parents: "Übergeordnet / Behälter",
children: "Untergeordnet / enthalten",
dependsOn: "Hängt ab von",
supports: "Unterstützt / beeinflusst",
related: "Verwandt",
canonical: "Hauptanlage",
duplicates: "Mögliche Duplikate",
},
emptyTitle: "Noch keine Beziehungen definiert",
emptyBody: "Verknüpfen Sie eine übergeordnete, eine Komponenten- oder eine gleichrangige Anlage, damit Abhängigkeiten und Auswirkungen bekannt sind.",
linkAsset: "Anlage verknüpfen",
linkAssetA11y: "Eine Anlage verknüpfen",
checkDuplicates: "Duplikate prüfen",
checkDuplicatesA11y: "Auf doppelte Anlagen prüfen",
setCanonical: "Als Hauptanlage festlegen",
merge: "Zusammenführen",
compare: "Vergleichen",
comparison: "Vergleich",
loadingGraph: "Graph wird geladen...",
mapAssets_one: "{{count}} Anlage",
mapAssets_other: "{{count}} Anlagen",
mapLinks_one: "{{count}} Verbindung",
mapLinks_other: "{{count}} Verbindungen",
mapImpacts_one: "betrifft von hier aus {{count}} verknüpfte Anlage",
mapImpacts_other: "betrifft von hier aus {{count}} verknüpfte Anlagen",
openAsset: "{{name}} öffnen",
editLink: "Verbindung zu {{name}} bearbeiten",
unlink: "Verbindung zu {{name}} aufheben",
treeLoading: "Wird geladen…",
treeThisAsset: "Diese Anlage",
treeChildren_one: "{{count}} untergeordnete Anlage",
treeChildren_other: "{{count}} untergeordnete Anlagen",
riskRelevant: "Risikorelevant",
informational: "Informativ",
linkCreated: "Verbindung erstellt",
linkAnother: "Weitere verknüpfen",
done: "Fertig",
type: {
contains: "Enthält",
part_of: "Teil von",
located_in: "Befindet sich in",
depends_on: "Hängt ab von",
supports: "Unterstützt",
connected_to: "Verbunden mit",
serves: "Versorgt",
powered_by: "Betrieben durch",
monitored_by: "Überwacht durch",
associated_with: "Verknüpft mit",
backup_for: "Ersatz für (Backup)",
replacement_for: "Ersatz für",
assigned_to: "Zugewiesen an",
installed_in: "Eingebaut in",
maintained_with: "Gewartet mit",
possible_duplicate_of: "Mögliches Duplikat von",
duplicate_of: "Duplikat von",
merged_into: "Zusammengeführt in",
},
verb: {
contains: "enthält",
part_of: "ist Teil von",
located_in: "befindet sich in",
depends_on: "hängt ab von",
supports: "unterstützt",
connected_to: "ist verbunden mit",
serves: "versorgt",
powered_by: "wird betrieben durch",
monitored_by: "wird überwacht durch",
associated_with: "ist verknüpft mit",
backup_for: "ist ein Backup für",
replacement_for: "ist ein Ersatz für",
assigned_to: "ist zugewiesen an",
installed_in: "ist eingebaut in",
maintained_with: "wird gewartet mit",
possible_duplicate_of: "ist möglicherweise ein Duplikat von",
duplicate_of: "ist ein Duplikat von",
merged_into: "wurde zusammengeführt in",
},
category: {
hierarchy: "Hierarchie",
dependency: "Abhängigkeiten",
association: "Verwandt",
duplicate: "Duplikate",
},
propagation: {
none: "Keine",
informational: "Informativ",
contributes_to_parent: "Wirkt sich auf die übergeordnete Anlage aus",
contributes_to_dependent: "Wirkt sich auf die abhängige Anlage aus",
bidirectional_warning: "Warnung in beide Richtungen",
},
form: {
addTitle: "Beziehung hinzufügen",
editTitle: "Beziehung bearbeiten",
close: "Schließen",
relatedAsset: "Verknüpfte Anlage",
chooseRelated: "Wählen Sie die Anlage, zu der diese in Beziehung steht",
choose: "Wählen",
change: "Ändern",
done: "Fertig",
edit: "Bearbeiten",
relationshipType: "Beziehungstyp",
swap: "Tauschen",
swapA11y: "Richtung tauschen",
riskAndNotes: "Risiko & Notizen",
criticality: "Kritikalität",
countsTowardsRisk: "Zählt zum Risiko",
riskRelevant: "Risikorelevant",
informationalOnly: "Nur informativ",
informationalHint: "{{type}}-Beziehungen sind informativ.",
propagation: "Risikoausbreitung",
reasonPlaceholder: "Grund für Kritikalität (optional)",
reasonA11y: "Grund für Kritikalität",
notesPlaceholder: "Notizen (optional)",
notesA11y: "Notizen",
notes: "Notizen",
cancel: "Abbrechen",
add: "Beziehung hinzufügen",
save: "Änderungen speichern",
saving: "Wird gespeichert...",
and: "{{a}} und {{b}}",
selectAssetTitle: "Anlage wählen",
selectAssetBody: "Wählen Sie eine Anlage für die Beziehung.",
couldNotAdd: "Beziehung konnte nicht hinzugefügt werden",
tryAgain: "Bitte versuchen Sie es erneut.",
},
edge: {
added: "Hinzugefügt am {{date}}",
edit: "Bearbeiten",
remove: "Entfernen",
close: "Schließen",
},
picker: {
  addAsset: "Anlage hinzufügen",
title: "Anlage",
relatedTitle: "Verknüpfte Anlage",
searchPlaceholder: "Nach Name, Standort oder ID suchen…",
searchA11y: "Anlagen suchen",
clearSearch: "Suche löschen",
allTypes: "Alle Typen",
searching: "Alle Anlagen werden durchsucht…",
noneYet: "Noch keine Anlagen.",
noMatchHint: "Keine passenden Anlagen. Versuchen Sie einen anderen Namen oder entfernen Sie den Typfilter.",
noMatch: "Keine passenden Anlagen.",
showingFirst: "Die ersten {{shown}} von {{total}} werden angezeigt. Tippen Sie weiter, um einzugrenzen.",
noAsset: "Keine Anlage",
clearSelection: "Auswahl löschen",
done: "Fertig",
close: "Schließen",
chooseAsset: "Anlage wählen",
changeA11y: "Anlage: {{name}}. Ändern",
},
},
relationshipNode: {
current: "Aktuelle Anlage",
unscored: "Zustand nicht bewertet",
loadingImpact: "Auswirkung wird geladen…",
impacts_one: "Betrifft {{count}} verwandte Anlage",
impacts_other: "Betrifft {{count}} verwandte Anlagen",
open: "Anlage öffnen",
addRelationship: "Beziehung hinzufügen",
viewWork: "Betroffene Arbeit anzeigen",
close: "Schließen",
},
documentsSection: {
  editDetails: "Details bearbeiten",
statusAll: "Alle",
statusExpired: "Abgelaufen",
statusExpiringSoon: "Läuft bald ab",
statusValid: "Gültig",
statusPending: "Ausstehend",
statusRejected: "Abgelehnt",
statusSupersededOrUndated: "Ersetzt oder undatiert",
typeAll: "Alle Typen",
typeCertificates: "Zertifikate",
typeWarranty: "Garantie",
typeCompliance: "Konformität",
typeGeneral: "Allgemein",
viewList: "Liste",
viewTimeline: "Zeitleiste",
viewCalendar: "Kalender",
viewLabel: "Ansicht",
loadingDocumentsA11y: "Dokumente werden geladen",
loadingDocumentsText: "Dokumente werden geladen…",
addDocumentA11y: "Dokument hinzufügen",
tryLoadingAgainA11y: "Versuchen Sie erneut, Dokumente zu laden",
refineDocumentsA11y: "Dokumente filtern",
searchDocumentsA11y: "Dokumente durchsuchen",
clearSearchA11y: "Suche zurücksetzen",
refineDocumentsTitle: "Dokumente filtern",
rejectionReasonA11y: "Ablehnungsgrund",
reasonPlaceholder: "Grund",
validateInTheirPlace: "An deren Stelle validieren",
openFile: "Datei öffnen",
validate: "Validieren",
renew: "Erneuern",
replace: "Ersetzen",
reject: "Ablehnen",
startInspection: "Inspektion starten",
createJob: "Auftrag erstellen",
planRenewal: "Verlängerung planen",
history: "Verlauf",
closeA11y: "Schließen",
metaIssued: "ausgestellt",
metaExpires: "läuft ab",
metaReminder: "Erinnerung",
metaReminderDays: "{{days}} Tage",
metaSource: "Quelle",
metaFile: "Datei",
metaValidatedBy: "Validiert von",
metaPrevious: "Zurück",
metaNext: "Weiter",
showPreviousMonthA11y: "Vorherigen Monat anzeigen",
showNextMonthA11y: "Nächsten Monat anzeigen",
showTodayA11y: "Heute anzeigen",
dateHintA11y: "Zeigt die an diesem Datum ausgestellten oder ablaufenden Dokumente",
documentHistoryTitle: "Dokumentverlauf",
noRenewalHistory: "Noch keine Verlängerungshistorie.",
historyEntry: "{{index}}. {{title}} - {{date}} - {{status}}",
historyCurrentStatus: "aktuell",
validateDocumentTitle: "Dokument validieren",
validateDocumentBody: "„{{title}}“ validieren und als aktiv markieren?",
cancel: "Abbrechen",
reasonRequiredTitle: "Grund erforderlich",
reasonRequiredBody: "Geben Sie einen Ablehnungsgrund ein, bevor Sie dieses Dokument ablehnen.",
pageTitle: "Dokumente",
pageSub: "Dateien, Zertifikate und Garantien, die für diese Anlage gespeichert sind.",
loadErrorText: "Dokumente konnten nicht geladen werden",
emptyText: "Noch keine Dokumente",
emptySub: "Zertifikate, Garantien und Handbücher für diese Anlage sind hier verfügbar, mit nachverfolgtem Ablaufdatum.",
tryAgain: "Erneut versuchen",
addDocumentButton: "Dokument hinzufügen",
viewOptionA11y: "{{label}} Ansicht",
refine: "Filtern",
searchPlaceholder: "Dokumente durchsuchen…",
rejectDocumentTitle: "Dokument ablehnen",
rejectDocumentBody: "Geben Sie den Grund ein, warum dieses Dokument nicht validiert werden kann.",
openDocumentA11y: "Öffnen Sie {{title}}",
rejectionReasonPrefix: "Ablehnungsgrund: {{reason}}",
noDocumentDates: "Keine Dokumentdaten",
documentDateCount_one: "{{count}} Dokumentdatum",
documentDateCount_other: "{{count}} Dokumentdaten",
dayCellA11y: "{{dateLabel}}. {{eventLabel}}.",
statusPendingValidation: "Validierung ausstehend",
statusSupersededLabel: "Ersetzt",
statusNoExpiryRecorded: "Kein Ablauf erfasst",
statusEvidenceMissing: "Nachweise fehlen",
kindIssued: "ausgestellt",
kindAdded: "Hinzugefügt",
kindExpires: "läuft ab",
openDocumentWithStatusA11y: "Öffnen Sie {{title}}. {{status}}.",
issuedOn: "Ausgestellt {{date}}",
addedOn: "Hinzugefügt am {{date}}",
expiresOnSuffix: " · Läuft am {{date}} ab",
noExpiryRecordedSuffix: " · Kein Ablaufdatum erfasst",
expiresLowerSuffix: " → läuft am {{date}} ab",
noExpiryRecordedLowerSuffix: " · kein Ablaufdatum erfasst",
today: "Heute",
},
guideMeSheet: {
subtitle: "Wählen Sie etwas aus, das Sie für diese Anlage einrichten möchten. Wir zeigen Ihnen Schritt für Schritt, worauf Sie tippen.",
},
graphInspector: {
selectedLink: "Ausgewählter Link",
},
decommissionSheet: {
title: "Außer Betrieb nehmen",
cancelA11y: "Stilllegung abbrechen",
reasonLabel: "Warum wird die Anlage außer Betrieb genommen?",
outOfServiceFromLabel: "Außer Betrieb ab",
noteLabel: "Notiz",
notePlaceholder: "Was das Team wissen sollte – z.B. Wärmetauscher gerissen, Ersatz bestellt.",
noteA11y: "Stilllegungshinweis",
makeSafeFirstTitle: "Machen Sie es zuerst sicher",
makeSafeFirstBodyOn_one: "Erstellt einen Auftrag mit {{count}} Sicherungsschritt als Nachprüfung. Die Anlage wird außer Betrieb genommen, sobald dieser Auftrag verifiziert ist.",
makeSafeFirstBodyOn_other: "Erstellt einen Auftrag mit {{count}} Sicherungsschritten als Nachprüfung. Die Anlage wird außer Betrieb genommen, sobald dieser Auftrag verifiziert ist.",
makeSafeFirstBodyOff: "Kein Auftrag. Die Anlage wird sofort außer Betrieb genommen; fügen Sie eine Notiz hinzu, wer das entschieden hat.",
makeSafeSwitchA11y: "Sicherungsauftrag erstellen, bevor die Anlage außer Betrieb geht",
confirmRaise: "Sicherungsauftrag anlegen",
confirmTakeOut: "Jetzt außer Betrieb nehmen",
},
dataQuality: {
bandComplete: "Profil komplett",
bandPartial: "Profil teilweise",
bandMissing: "Details fehlen",
title: "Anlagenprofil",
subtitleAllComplete_one: "{{total}} zutreffendes Profilfeld ist vollständig.",
subtitleAllComplete_other: "Alle {{total}} anwendbaren Profilfelder sind vollständig.",
subtitleAddLead: "{{label}} hinzufügen – {{unlock}}.",
subtitleAddMissing: "Fügen Sie die fehlenden strukturierten Details hinzu, um dieses Anlagenprofil zu vervollständigen.",
addGapA11y: "{{label}} hinzufügen – {{unlock}}",
applySuggestions_one: "{{count}} KI-Vorschlag anwenden",
applySuggestions_other: "{{count}} KI-Vorschläge anwenden",
confidenceMediumLabel: "Mittlere Sicherheit",
confidenceMediumBody: "Die KI arbeitet mit begrenzten Details an dieser Anlage.",
confidenceLowLabel: "Geringe Sicherheit",
confidenceLowBody: "Diese Anlage verfügt über wenige strukturierte Daten. Betrachten Sie daher die KI-Ausgabe als Ausgangspunkt.",
confidenceA11y: "{{label}}. {{body}} Verbessern Sie die Datenqualität.",
confidenceBodySuffix: "{{body}} Daten verbessern →",
},
activitySection: {
who: "Wer: {{name}}",
when: "Wann: {{when}}",
refineActivity: "Aktivität filtern",
refine: "Filtern",
searchActivityPlaceholder: "Aktivität durchsuchen…",
searchActivityA11y: "Aktivität durchsuchen",
clearSearchA11y: "Suche zurücksetzen",
hideSearchA11y: "Suche ausblenden",
noActivityOnDate: "Keine Aktivität an diesem Datum",
noActivityHint: "Wählen Sie einen anderen Tag oder ändern Sie den Filter oder die Suche.",
view: "Ansicht",
timeline: "Zeitleiste",
calendar: "Kalender",
status: "Status",
all: "Alle",
outstanding: "Offen",
planned: "Geplant",
completed: "Abgeschlossen",
inspections: "Inspektionen",
jobs: "Aufträge",
documents: "Dokumente",
},
actionsSection: {
uploadDocumentA11y: "Dokument hochladen",
uploadDoc: "Dokument hochladen",
},
portfolioGraphPanel: {
couldNotLinkTitle: "Konnte keine Verknüpfung herstellen",
createRelationshipFailed: "Die Beziehung konnte nicht erstellt werden.",
couldNotRemoveTitle: "Konnte nicht entfernt werden",
failed: "Fehlgeschlagen.",
emptyTitle: "Keine Anlagen zum Visualisieren",
emptySub: "Erstellen Sie Ihre erste Anlage, um das Netzwerk zu sehen.",
useListView: "Listenansicht verwenden",
},
portfolioContextualBar: {
linkTypeHeader: "Linktyp · {{source}} → {{target}}",
defaultSourceName: "Quelle",
defaultTargetName: "Ziel",
pickTypeHint: "Wählen Sie einen Typ oder verwenden Sie Weitere Optionen für vollständige Details.",
moreOptions: "Weitere Optionen",
editOnSource: "Bearbeiten der Quelle",
criticalityBadge: "{{criticality}} Kritikalität",
impactsRelated_one: "Betrifft {{count}} verknüpfte Anlage",
impactsRelated_other: "Betrifft {{count}} verknüpfte Anlagen",
connectFromHere: "Von hier aus eine Verbindung herstellen",
},
portfolioGraphContextRow: {
exit: "Beenden",
connect: "Verbinden",
},
listRow: {
canRequestWork: "Kann Arbeit anfordern",
readOnly: "Schreibgeschützt",
overdue: "Überfällig",
next: "Als Nächstes",
nextStepLabel: "{{prefix}}: {{scheduleLabel}} {{time}}",
recommendedRaiseJob: "Empfohlen: Auftrag erstellen",
recommendedInspect: "Empfohlen: Überprüfen",
healthSuffix: "Zustand: {{status}}",
needsAttention: "braucht Aufmerksamkeit",
openNextStep: "{{label}} öffnen",
recommendRaiseJobA11y: "Empfohlene nächste Aktion: Einen Arbeitsauftrag erteilen",
recommendInspectA11y: "Empfohlene nächste Aktion: Starten Sie eine Inspektion",
directionsTo: "Wegbeschreibung zu {{name}}",
relationshipsFor: "Beziehungen für {{name}}",
},
shareSection: {
invitePending: "Einladung ausstehend",
inviteRequired: "Einladung erforderlich",
active: "Aktiv",
title: "Freigegebene Kontakte",
subtitle: "Jeder hier aufgeführte Benutzer kann diese Anlage entsprechend seiner Rolle und Berechtigungen im freigegebenen Arbeitsbereich öffnen.",
shareWithContact: "Mit Kontakt teilen",
loading: "Geteilte Kontakte werden geladen…",
empty: "Bisher haben keine Kontakte Zugriff auf diese Anlage. Teilen Sie sie mit einem Kontakt, damit dieser Inspektionen anfordern oder Arbeitsaufträge vorschlagen kann.",
linkedContactFallback: "Verknüpfter Kontakt",
noRelationshipLinked: "Keine Anlagenbeziehung verknüpft",
collaborationRole: "Kollaborationsrolle: {{role}}",
collaborationRoleWithStatus: "Kollaborationsrolle: {{role}} · {{status}}",
canView: "Darf ansehen",
lockedFeatureName: "Teilen mit Kontakten",
canRequestInspection: "Kann eine Inspektion anfordern",
canProposeJob: "Kann einen Arbeitsauftrag vorschlagen",
yes: "Ja",
no: "Nein",
workspaceVisibility: "Sichtbarkeit des Arbeitsbereichs: {{detail}}",
openRequests: "Offene Anfragen: {{count}}",
openRequestsWithLast: "Offene Anfragen: {{count}} · Letzte Anfrage {{date}}",
openRequestsNoneYet: "Offene Anfragen: {{count}} · Noch keine Anfragen",
inviteSentResendHint: "Einladung gesendet. Senden Sie sie erneut, falls sie nicht angekommen ist.",
inviteSendHint: "Senden Sie eine Einladung, damit sie ihr Konto verknüpfen und auf diese Anlage zugreifen können.",
working: "Wird bearbeitet…",
resendInvite: "Einladung erneut senden",
sendInvite: "Einladung senden",
editPermissions: "Berechtigungen bearbeiten",
revokeAccess: "Zugriff entziehen",
viewContact: "Kontakt anzeigen",
viewRequests: "Anfragen anzeigen",
},
listSignalPills: {
riskDefaultLabel: "Risiko",
overdueJob_one: "überfälliger Arbeitsauftrag",
overdueJob_other: "überfällige Arbeitsaufträge",
complianceLabel: "Konformität",
},
overviewQuickActions: {
defaultTitle: "Schnellaktionen",
},
imageCarousel: {
photoPosition: "Foto {{current}} von {{total}}",
photoSingle: "Foto",
labeledPosition: "{{label}}, {{position}}",
viewFullSize: "{{label}}. Vollbild anzeigen",
previousPhoto: "Vorheriges Foto",
nextPhoto: "Nächstes Foto",
goToPhoto: "Gehen Sie zum Foto {{current}} von {{total}}",
},
imageLightbox: {
defaultTitle: "Anlagenfotos",
closeA11y: "Schließen",
},
conditionAccordion: {
a11yLabelExpanded: "{{title}}, erweitert",
a11yLabelCollapsed: "{{title}}, eingeklappt",
},
impactChip: {
a11yLabel_one: "Diese Anlage versorgt {{count}} verknüpfte Anlage – deren Arbeit anzeigen",
a11yLabel_other: "Diese Anlage versorgt {{count}} verknüpfte Anlagen – deren Arbeit anzeigen",
text_one: "Versorgt {{count}} verknüpfte Anlage – Probleme hier können deren Arbeit beeinträchtigen",
text_other: "Versorgt {{count}} verknüpfte Anlagen – Probleme hier können deren Arbeit beeinträchtigen",
},
assetDetailsPanel: {
roomCounts: "Anzahl der Räume",
bedrooms: "Schlafzimmer",
bathrooms: "Badezimmer",
kitchens: "Küchen",
livingRooms: "Wohnzimmer",
diningRooms: "Esszimmer",
utilityRooms: "Hauswirtschaftsräume",
garages: "Garagen",
parkingSpaces: "Parkplätze",
amenities: "Ausstattung",
garden: "Garten",
driveway: "Auffahrt",
balcony: "Balkon",
ensuite: "Eigenes Bad",
outbuilding: "Nebengebäude",
basement: "Keller",
loft: "Dachboden",
furnishing: "Einrichtung",
systems: "Systeme",
facilityCounts: "Anzahl der Einrichtungen",
units: "Einheiten",
toilets: "Toiletten",
kitchenettes: "Küchenzeilen",
loadingBays: "Ladebuchten",
lifts: "Aufzüge",
facilityFeatures: "Ausstattungsmerkmale",
reception: "Empfang",
plantRoom: "Technikraum",
fireAlarm: "Feueralarm",
sprinklers: "Sprinkler",
accessControl: "Zugangskontrolle",
shutterDoors: "Rolltore",
condition: "Zustand",
capacity: "Kapazität",
seatingCapacity: "Sitzplatzkapazität",
loadCapacity: "Tragfähigkeit",
datesService: "Termine & Service",
year: "Jahr",
yearPlaceholder: "z.B. 2024",
odometer: "Kilometerzähler",
roadCompliance: "Straßenzulassung",
capacityElectrical: "Kapazität und Elektrik",
voltage: "Spannung",
phase: "Phase",
capacityValue: "Kapazitätswert",
serviceSchedule: "Serviceplan",
serviceIntervalDays: "Serviceintervall (Tage)",
details: "Details",
coreDetails: "Kerndetails",
propertyDetails: "Immobiliendetails",
propertyDetailsHint: "Wählen Sie zuerst eine Immobilienkategorie, damit nur die passenden Abschnitte angezeigt werden.",
retrySavingDetails: "Versuchen Sie erneut, die Details zu speichern",
structuredDetailsFor: "Strukturierte Details für diese Anlage ({{assetType}}).",
noStructuredDetails: "Es wurden noch keine strukturierten Details bestätigt.",
assetProfileDetails: "Details zum Anlagenprofil",
coreDetailsConfirmed: "Kerndetails für diese Anlage wurden bestätigt.",
hiddenUntilPropertyChosen: "Raumanzahlen, Einrichtungsdetails und KI-Felder bleiben ausgeblendet, bis die Immobilienart gewählt ist.",
unsavedChanges: "Nicht gespeicherte Änderungen…",
saving: "Wird gespeichert…",
saved: "Gespeichert",
couldNotSaveChanges: "Ihre Änderungen konnten nicht gespeichert werden.",
changesSaveAutomatically: "Änderungen werden automatisch gespeichert.",
retry: "Wiederholen",
coreFieldsFilled: "{{completed}} von {{total}} Kernfeldern ausgefüllt",
stillMissing: "Es fehlt noch: {{labels}}",
applySeededSuggestions_one: "{{count}} vorbefüllten Vorschlag anwenden",
applySeededSuggestions_other: "{{count}} vorbefüllte Vorschläge anwenden",
applySeededSuggestionsZero: "Vorbefüllte Vorschläge übernehmen",
appliedSuggestions_one: "{{count}} Vorschlag übernommen – prüfen Sie die Felder unten; sie werden automatisch gespeichert.",
appliedSuggestions_other: "{{count}} Vorschläge übernommen – prüfen Sie die Felder unten; sie werden automatisch gespeichert.",
noSuggestionsToFill: "Diese Details stimmen bereits mit jedem gesetzten Vorschlag überein – es gibt nichts auszufüllen.",
lifecycle: "Lebenszyklus",
criticality: "Kritikalität",
compliance: "Konformität",
furnishedStatus: "Möblierung",
location: "Standort",
otherCategory: "Andere Kategorie",
subtypeDetailLegacy: "Untertyp-Detail (alt)",
yes: "Ja",
no: "Nein",
unknown: "Unbekannt",
viewQrCode: "QR-Code anzeigen",
hideQrCode: "QR-Code ausblenden",
},
imageDrawModal: {
colorRed: "Rot",
colorAmber: "Bernstein",
colorGreen: "Grün",
colorWhite: "Weiß",
toolDraw: "Zeichnen",
toolArrow: "Pfeil",
toolBox: "Rechteck",
toolCircle: "Kreis",
toolText: "Text",
couldNotSaveMarkupTitle: "Markierungen konnten nicht gespeichert werden",
couldNotSaveMarkupBody: "Das Foto wurde ohne Markierungen hinzugefügt.",
clearAllMarkupTitle: "Alle Markierungen löschen?",
clearAllMarkupBody: "Dadurch werden alle Markierungen auf dem Foto entfernt.",
cancel: "Abbrechen",
clear: "Zurücksetzen",
cancelMarkupA11y: "Markieren abbrechen",
doneA11y: "Fertig",
done: "Fertig",
markupTitle: "Markierungen",
labelThisPointPlaceholder: "Beschriften Sie diesen Punkt",
markupTextA11y: "Markierungstext",
addTextA11y: "Text hinzufügen",
add: "Hinzufügen",
cancelTextA11y: "Text verwerfen",
undoLastMarkA11y: "Letzte Markierung rückgängig machen",
undo: "Rückgängig machen",
clearAllMarkupA11y: "Löschen Sie alle Markierungen",
},
qrScanner: {
enterCodeTitle: "Code eingeben",
enterCodeBody: "Bitte fügen Sie einen QR-Codewert ein oder geben Sie ihn ein.",
qrCodeTitle: "QR-Code",
qrCodeValueA11y: "QR-Codewert",
webUnavailableMessage: "Das Scannen mit der Kamera ist im Web nicht verfügbar. Fügen Sie unten einen QR-Codewert ein oder verwenden Sie zum Scannen die App auf Ihrem Telefon.",
pasteOrTypePlaceholder: "QR-Codewert einfügen oder eingeben…",
resolveCode: "Code abrufen",
cancel: "Abbrechen",
requestingPermission: "Kameraerlaubnis wird angefordert...",
permissionRequiredTitle: "Kameraerlaubnis erforderlich",
permissionRequiredMessage: "Zum Scannen von QR-Codes ist Kamerazugriff erforderlich. Bitte aktivieren Sie die Kameraberechtigungen in Ihren Geräteeinstellungen.",
grantPermission: "Erlaubnis erteilen",
typeCodeUnderQrPlaceholder: "Oder geben Sie den unter dem QR-Code aufgedruckten Code ein…",
scanQrCodeTitle: "Scannen Sie den QR-Code",
closeScannerA11y: "Scanner schließen",
typeCodeUnderQrShortPlaceholder: "Geben Sie den unter dem QR-Code aufgedruckten Code ein",
positionQrHint: "Positionieren Sie den QR-Code innerhalb des Rahmens",
backToCameraA11y: "Zurück zur Kamera",
enterCodeInsteadA11y: "Geben Sie stattdessen den Code ein",
backToCamera: "Zurück zur Kamera",
cantScanEnterCode: "Scannen klappt nicht? Geben Sie stattdessen den Code ein",
scanned: "Gescannt",
},
measureView: {
spokenClear: "Zurücksetzen",
spokenDivide: "Teilen",
spokenMultiply: "Multiplizieren",
spokenBackspace: "Rücktaste",
spokenMinus: "Minus",
spokenPlus: "Plus",
spokenEquals: "Gleich",
spokenDecimalPoint: "Komma",
captureReading: "Messwert erfassen",
},
dictateView: {
stopDictation: "Diktat beenden",
startDictation: "Diktat starten",
listening: "Zuhören…",
stopped: "Angehalten",
tapToTalk: "Tippen Sie, um zu sprechen",
speakNaturally: "Sprechen Sie ganz natürlich – die KI legt den richtigen Eintrag an.",
transcriptPlaceholder: "Während Sie sprechen, wird Ihr Transkript hier angezeigt.",
clear: "Zurücksetzen",
useTranscript: "Transkript verwenden",
},
dictateCapture: {
issueDraftLabel: "Entwurf: Problemmeldung",
issueDraftDetail: "Sieht nach einem Defekt aus – Copilot kann ein Problem melden.",
noteLabel: "Notiz",
noteDetail: "Wird als einfache Notiz im Zusammenhang mit dem aktuellen Kontext erfasst.",
},
omniCaptureSheet: {
modePhoto: "Foto",
modePhotoHint: "Machen Sie ein Foto oder wählen Sie eines aus. Die Bildunterschrift wird automatisch vorgeschlagen.",
modeDictate: "Diktieren",
modeDictateHint: "Sprechen Sie es einfach durch; die KI legt den richtigen Eintrag an.",
modeScan: "QR scannen",
modeScanHint: "Springen Sie zur verknüpften Anlage.",
modeMeasure: "Messen",
modeMeasureHint: "Erfassen Sie einen Messwert oder führen Sie eine schnelle Berechnung durch.",
modeNote: "Notiz",
modeNoteHint: "Nur-Text-Notiz im Zusammenhang mit dem Kontext.",
defaultTitle: "Erfassen",
backA11y: "Zurück",
closeA11y: "Schließen",
forScope: "Für: {{scope}}",
noteA11y: "Notiz",
notePlaceholder: "Eine Notiz hinzufügen...",
saveNoteA11y: "Notiz speichern",
saveNote: "Notiz speichern",
},
workLocationFlag: {
defaultAssetName: "die Anlage",
locationCheckWaiting: "Standortprüfung wartet",
recordedAway: "Außerhalb der Anlage aufgezeichnet",
carriedOutWithDistance: "Diese Arbeit wurde {{distance}} entfernt von dem Ort durchgeführt, an dem {{name}} erfasst ist.",
carriedOutNoDistance: "Diese Arbeit wurde außerhalb des Ortes durchgeführt, an dem {{name}} aufgezeichnet ist.",
pendingSuffix: " Das Team, das die Anlage verwaltet, hat noch nicht geantwortet.",
reviewedSuffix: " Überprüft: Die Anlage wurde nicht verschoben.",
},
what3wordsField: {
useSuggestion: "Verwenden Sie {{words}}",
},
assetMoveSheet: {
reasonMoved: "Sie wurde verlegt",
reasonMovedHint: "Die Anlage befindet sich physisch an einem neuen Ort",
reasonCorrected: "Es war falsch",
reasonCorrectedHint: "Die Anlage befand sich nie dort, wo sie in der Aufzeichnung stand",
title: "Verschieben Sie {{assetName}}",
whatHappened: "Was ist passiert?",
whereIsItNow: "Wo ist es jetzt?",
whenDidItMove: "Wann ist es umgezogen?",
today: "Heute",
yesterday: "Gestern",
lastWeek: "Letzte Woche",
overAMonthAgo: "Vor über einem Monat",
noteOptional: "Hinweis (optional)",
notePlaceholder: "z.B. Umzug in den Technikraum im Untergeschoss",
recordTheMove: "Standortwechsel erfassen",
correctTheLocation: "Korrigieren Sie den Standort",
cancel: "Abbrechen",
},
locationClaimReview: {
fieldResponseAssetIsHere: "Die Person vor Ort bestätigte, dass sich die Anlage dort befindet",
fieldResponseAssetNotHere: "Die Person vor Ort sagte, die Anlage sei NICHT da",
fieldResponseUnsure: "Die Person vor Ort war sich nicht sicher",
fieldResponseDeviceReported: "Ein angeschlossenes Gerät hat die Anlage von dort gemeldet – niemand wurde gefragt",
defaultAssetName: "Diese Anlage",
stillWhereWeThinkTitle: "Ist {{name}} immer noch dort, wo wir denken?",
unknownDistance: "Unbekannte Entfernung",
betweenRecordedAndSource: "zwischen dem aufgezeichneten Standort und {{source}}",
updateAssetLocation: "Anlagenstandort aktualisieren",
hasNotMoved: "Nein, es hat sich nicht bewegt",
whyNotMovedTitle: "Warum hat es sich nicht bewegt?",
whyNotMovedMessage: "Dies wird im Inspektions- oder Arbeitsauftrag festgehalten, sodass die Person, die es gemeldet hat, sehen kann, was entschieden wurde.",
whyNotMovedPlaceholder: "z. B. Die Anlage steht noch im Technikraum; der Techniker war am falschen Standort",
rejectAndFlag: "Die Arbeit ablehnen und markieren",
},
locationField: {
defaultAddressLabel: "Adresse",
searchAddressPlaceholder: "Adresse suchen…",
pinSavedAccurate: "Pin gespeichert, auf etwa {{meters}} m genau",
pinSaved: "Pin gespeichert",
level: "Ebene",
levelIndexPlaceholder: "0 = Erdgeschoss, -2 = 2. Untergeschoss",
levelName: "Ebenenname",
levelNamePlaceholder: "z.B. Keller 2, Dach",
depthLabel: "Tiefe unter der Erde (Meter)",
depthPlaceholder: "z.B. 3,2 für eine erdverlegte Hauptleitung",
doesItMove: "Bewegt es sich?",
useCurrentLocation: "Aktuellen Standort verwenden",
},
locationCheckPrompt: {
isHereTitle: "Ist {{assetName}} hier?",
assetIsHere: "Ja, die Anlage ist hier",
assetNotHere: "Nein, die Anlage befindet sich woanders",
unsure: "Ich bin nicht sicher",
explainWithDistance: "Diese Arbeit wurde {{distance}} entfernt von dem Ort erfasst, an dem {{assetName}} hinterlegt ist.",
explainNoDistance: "Diese Arbeit wurde nicht dort erfasst, wo {{assetName}} hinterlegt ist.",
reassure: "Ihre Antwort geht an das Team, das diese Anlage verwaltet. Es ändert sich nichts, bis sie es bestätigen.",
},
actionPickerHost: {
share: {
title: "Eine Anlage teilen",
subtitle: "Wählen Sie die Anlage aus, die Sie teilen möchten.",
},
report: {
title: "Ein Problem melden",
subtitle: "Wählen Sie die Anlage aus, für die Sie ein Problem melden möchten.",
},
meterReading: {
title: "Zeichnen Sie einen Messwert auf",
subtitle: "Wählen Sie die Anlage aus, zu der der Zähler gehört.",
},
maintenancePlan: {
title: "Fügen Sie einen Wartungsplan hinzu",
subtitle: "Wählen Sie die Anlage aus, für die der Plan gilt.",
},
inspection: {
title: "Eine Inspektion starten",
subtitle: "Wählen Sie die Anlage aus, die Sie prüfen möchten.",
},
job: {
title: "Einen Auftrag erfassen",
subtitle: "Wählen Sie die Anlage aus, für die der Auftrag gilt.",
},
},
assetDetailScreen: {
  contactInteraction: {
    unknownName: "Unbekannt",
    approvalReceived: "Freigabe erhalten",
    reportShared: "Bericht geteilt",
  },
  lastInspectionOutcome: {
    inProgress: "Inspektion läuft",
    completed: "Letzte Inspektion abgeschlossen",
    failed: "Bei der letzten Inspektion durchgefallen",
  },
  kpiInfo: {
    profileA11y: "Angaben zu {{score}} % ausgefüllt. Öffnet die Details.",
    profilePill: "Angaben zu {{score}} % ausgefüllt",
    healthA11y: "Betriebszustand: {{status}}",
    noSchedule: "Nichts geplant",
    doneCount: "Erledigt: {{n}}",
    scheduledCount: "Geplant: {{n}}",
    overdueCount: "Überfällig: {{n}}",
    noOpenJobs: "Keine offenen Aufträge",
    openJobsBasedOn: "{{open}} von {{total}} Aufträgen dieser Anlage",
    openJobsDescription: "Aufträge zu dieser Anlage, die noch nicht abgeschlossen oder storniert sind. Ein Auftrag, der auf Abnahme wartet, zählt noch.",
    complianceBasedOn: "Hinterlegte Dokumente: {{n}}",
    complianceGuidance: "Tippen Sie auf die Kachel, um jedes Dokument zu sehen.",
    complianceDescription: "Ein Wert von 0 bis 100 für die Zertifikate und Dokumente, die diese Art von Anlage braucht; er sinkt, je näher der Ablauf rückt.",
    riskEmpty: "Noch keine Inspektion, daher kann das Risiko nicht berechnet werden.",
    riskBasedOn: "Letzte Inspektion {{date}}",
    riskGuidance: "Tippen Sie auf die Kachel, um die Berechnung zu sehen.",
    riskDescription: "Wie wahrscheinlich ein Problem ist, mal wie schwer es wäre, jeweils 1 bis 5 aus der letzten Inspektion und der Wichtigkeit der Anlage. 25 ist das Maximum; ab 15 ist hoch.",
    healthBasedOn: "{{open}} offene Aufträge · {{overdue}} überfällig · {{failed}} nicht bestandene Punkte · letzte Inspektion {{last}}",
    healthEmpty: "Für diese Anlage ist noch keine Inspektion, kein Zertifikat und kein Auftrag erfasst.",
    healthGuidance: "Tippen Sie auf die Kachel, um zu sehen, was den Wert verändert hat und was als Nächstes zu tun ist.",
    healthDescription: "Betriebszustand: ein Wert von 0 bis 100 aus Zertifikaten, Inspektionsergebnissen, offenen und überfälligen Aufträgen und dem Alter der Anlage. Ab 80 Gut, 55 bis 79 Beobachten, unter 55 Schlecht. Die Zustandsbewertung 1–5 aus Inspektionen ist ein eigener Wert.",
    never: "nie",
    noInspectionYet: "Noch keine Inspektion",
    nothingYet: "Noch nichts erfasst",
    unavailable: "Nicht geladen",
  },
  approver: {
    anyoneInTeam: "Jede Person im Team",
    anyoneIn: "Jede Person in {{team}}",
  },
  header: {
    subtitle: "{{lifecycle}} · {{site}} · Eigentümer {{owner}}",
    noSite: "Noch kein Standort",
  },
  blocked: {
    archivedNoJobs: "Für archivierte Anlagen können keine Aufträge angelegt werden.",
    retiredNoJobs: "Für ausgemusterte Anlagen können keine Aufträge angelegt werden.",
    archivedNoInspections: "Für archivierte Anlagen können keine Inspektionen gestartet werden.",
    retiredNoInspections: "Für ausgemusterte Anlagen können keine Inspektionen gestartet werden.",
    decommissionedBody: "Holen Sie es zuerst zurück: Tippen Sie oben auf Wieder in Betrieb nehmen. Das startet eine Inspektion und dann die gefundenen Aufträge.",
    plannedBody: "Nehmen Sie es zuerst in Betrieb: Tippen Sie oben auf In Betrieb nehmen. Das startet eine Inspektion und dann die gefundenen Aufträge.",
    archivedBody: "Sie können es weiter ansehen und bearbeiten. Um Inspektionen oder Aufträge hinzuzufügen, holen Sie es über das Menü ⋯ aus dem Archiv.",
    retiredBody: "Der Verlauf bleibt lesbar, aber Sie können keine Inspektionen oder Aufträge hinzufügen. Eigentümer oder Admins können es über das Menü ⋯ wiederherstellen.",
    archivedTitle: "Diese Anlage ist archiviert",
    retiredTitle: "Diese Anlage ist ausgemustert",
  },
  commissionCase: {
    returnStep: "Alles ist geprüft. Tippen Sie auf {{label}}.",
    fixStep: "Schließen Sie jeden Auftrag aus der Inspektion ab und prüfen Sie ihn. Danach können Sie es wieder in Betrieb nehmen.",
    inspectStep: "Als Nächstes: Tippen Sie auf Inspektion starten. Danach folgen die gefundenen Aufträge.",
    recommissioningTitle: "Wiederinbetriebnahme",
    commissioningTitle: "Inbetriebnahme",
  },
  teamMove: {
    movedToPersonal: "Zu Persönlich verschoben. Nur Sie können es jetzt sehen.",
    movedToTeam: "Zu {{team}} verschoben. Alle im Team können es jetzt sehen und bearbeiten.",
  },
  knowledgeShare: {
    openLink: "Alle mit dem Link",
    contact: "Kontakt",
    wholeLibrary: "Gesamte Bibliothek",
    oneItem: "Ein Eintrag",
    failedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    failedTitle: "Link nicht erstellt",
    chooseContactBody: "Tippen Sie auf Kontakt wählen und wählen Sie, für wen der Link ist.",
    chooseContactTitle: "Kontakt wählen",
    noMailBody: "Der Link ist kopiert. Fügen Sie ihn stattdessen in eine Nachricht ein.",
    noMailTitle: "Keine Mail-App",
    emailBody: "Öffnen Sie diesen Link zum Lesen: {{url}}",
    emailSubject: "Mit Ihnen geteilte Informationen",
    done: "Fertig",
    emailIt: "E-Mail an {{name}}",
    copiedBodyEmail: "Tippen Sie auf E-Mail, um ihn {{name}} aus Ihrer Mail-App zu senden, oder fügen Sie ihn in eine Nachricht ein.",
    copiedBody: "Fügen Sie ihn in eine Nachricht an {{name}} ein. Erst dann wird etwas gesendet.",
    linkTitle: "Freigabelink",
    copiedTitle: "Link kopiert",
    hintItem: "Wählen Sie, für wen der Link ist. Wer den Link hat, kann diesen Eintrag öffnen – senden Sie ihn nur dieser Person. Sie können einen Link unten jederzeit beenden.",
    hintLibrary: "Wählen Sie, für wen der Link ist. Wer den Link hat, kann das gesamte Wissen zu dieser Anlage öffnen – senden Sie ihn nur dieser Person. Sie können einen Link unten jederzeit beenden.",
    invalidUrlBody: "Geben Sie die vollständige Webadresse mit https:// ein, zum Beispiel https://example.com/handbuch.",
    invalidUrlTitle: "Webadresse prüfen",
    saving: "Wird gespeichert…",
    save: "Speichern",
  },
loadingDetails: "Anlagendetails werden geladen...",
assetNotFound: "Anlage nicht gefunden",
loadErrorTitleRetryable: "Diese Anlage konnte nicht geladen werden",
loadErrorTitleFinal: "Diese Anlage kann nicht angezeigt werden",
assetOptionsA11y: "Anlagenoptionen",
changeApproverA11y: "Ändern Sie, wer die Arbeit an dieser Anlage genehmigt",
change: "Ändern",
createdBanner: {
title: "Anlage erstellt",
subtitle: "Starten Sie die empfohlene Inspektion, melden Sie ein Problem oder fügen Sie optionale Details hinzu.",
inspectNow: "Jetzt prüfen",
inspectNowA11y: "Überprüfen Sie diese Anlage jetzt",
reportIssue: "Problem melden",
reportIssueA11y: "Ein Problem für diese Anlage melden",
addDetails: "Details hinzufügen",
addDetailsA11y: "Fügen Sie optionale Anlagendetails hinzu",
share: "Teilen",
shareA11y: "Teilen Sie diese Anlage mit einem Kontakt",
dismissA11y: "Schließen",
},
capture: {
notSavedTitle: "Aufnahme nicht gespeichert",
notFoundBody: "Diese Aufnahme konnte nicht gefunden werden. Bitte erfassen Sie sie noch einmal.",
mismatchBody: "Diese Erfassung stimmt nicht mit der aktuellen Anlage überein.",
photoAdded: "Foto zur Anlage hinzugefügt",
notesUpdated: "Anlagenhinweise aktualisiert",
measurementAdded: "Messung zu Anlagennotizen hinzugefügt",
notSupportedTitle: "Aufnahme nicht unterstützt",
notSupportedBody: "QR-Scan wird vom Scanner durchgeführt und nicht in Anlagen gespeichert.",
noPhotoCaptured: "Es wurde kein Foto aufgenommen.",
signInRequiredForPhotos: "Sie müssen angemeldet sein, um Fotos speichern zu können.",
noNoteCaptured: "Es wurde kein Notiztext erfasst.",
modeNotSupported: "Dieser Erfassungsmodus wird für Anlagen nicht unterstützt.",
},
tryAgain: "Bitte erneut versuchen.",
contactsAlerts: {
  pickerCreateLabel: "Kontakt anlegen und verknüpfen",
  pickerLinkTitle: "Kontakt verknüpfen",
  pickerShareTitle: "Mit einem Kontakt teilen",
  defaultInviterName: "Eine Kollegin oder ein Kollege",
  linkedBody: "{{name}} ist jetzt mit dieser Anlage verknüpft.",
  sharedAndInvitedBody: "Mit {{name}} geteilt. Wir haben {{email}} eine Einladung geschickt; nach dem Annehmen ist die Anlage sichtbar.",
  sharedWithBody: "Mit {{name}} geteilt. Die Anlage ist jetzt in AssetWRX für diese Person sichtbar.",
emailRequiredTitle: "E-Mail erforderlich",
emailRequiredBody: "Fügen Sie diesem Kontakt eine E-Mail hinzu, bevor Sie eine Einladung senden.",
inviteFailedTitle: "Einladung kann nicht gesendet werden",
selectRelationshipTitle: "Beziehung auswählen",
selectRelationshipBody: "Wählen Sie vor dem Speichern mindestens einen Beziehungstyp aus.",
accessSaveFailedTitle: "Der Kontaktzugriff konnte nicht gespeichert werden",
accessUpdateFailedTitle: "Zugriff kann nicht aktualisiert werden",
resendInviteFailed: "Die Einladung kann nicht erneut gesendet werden.",
inviteSent: "Einladung gesendet",
inviteUpdated: "Einladung aktualisiert",
inviteCreated: "Einladung erstellt",
inviteEmailSentBody: "Einladungs-E-Mail an {{email}} gesendet.",
inviteRefreshedEmailFailedBody: "Einladung aktualisiert, aber die E-Mail-Zustellung ist fehlgeschlagen. Sie können es erneut versuchen.",
inviteSavedEmailFailedBody: "Einladung für {{email}} gespeichert. E-Mail konnte nicht gesendet werden{{errorSuffix}}.",
inviteErrorSuffix: ": {{error}}",
defaultContactName: "Kontakt",
savedTitle: "Gespeichert",
sharedWithCountBody_one: "Mit {{count}} Kontakt geteilt. Senden Sie bei Bedarf Einladungen über den gemeinsamen Zugriff.",
sharedWithCountBody_other: "Mit {{count}} Kontakten geteilt. Senden Sie bei Bedarf Einladungen über den gemeinsamen Zugriff.",
linkedCountBody_one: "{{count}} Kontakt verknüpft.",
linkedCountBody_other: "{{count}} Kontakte verknüpft.",
linkContactFailed: "Kontakt kann nicht mit den ausgewählten Beziehungstypen verknüpft werden.",
inviteRequiredTitle: "Einladung erforderlich",
inviteRequiredNoEmailBody: "Der Zugriff ist gespeichert, aber der Kontakt hat keine E-Mail-Adresse und kann nicht benachrichtigt werden. Ergänzen Sie die E-Mail beim Kontakt und tippen Sie unter Geteilter Zugriff auf Einladung senden.",
inviteRequiredBody: "Gemeinsamer Zugriff wird gespeichert. Senden Sie jetzt eine Kontakteinladung, damit diese Person ihr Konto verknüpfen und die Anlage sehen kann.",
notNow: "Später",
sendInvite: "Einladung senden",
inviteSentAcceptedBody: "Eine Einladung wurde an {{email}} gesendet. Nach der Annahme können sie auf diese freigegebene Anlage zugreifen.",
inviteCreatedDeliveryFailedBody: "Einladung für {{email}} erstellt, aber die E-Mail-Zustellung ist fehlgeschlagen. Sie können über den gemeinsamen Zugriff erneut senden.",
inviteFailedFallback: "Die Freigabe wurde gespeichert, aber die Einladung ist fehlgeschlagen. Bitte versuchen Sie es noch einmal über die Kontakte.",
},
lifecycle: {
  standingA11y: "Status: {{label}}",
  locationCorrected: "Standort korrigiert.",
  moveRecorded: "Umzug gespeichert. Der alte Standort bleibt im Verlauf.",
decommissioningTitle: "Stilllegung",
decommissioningDetail: "Wird außer Betrieb genommen, sobald der Sicherungsauftrag verifiziert ist{{jobStatusSuffix}}.",
decommissioningJobStatusSuffix: " – Auftragsstatus: {{status}}",
startCommissioningFailedTitle: "Die Inbetriebnahme konnte nicht gestartet werden",
backInService: "Wieder im Einsatz",
returnToServiceFailedTitle: "Diese Anlage konnte nicht wieder in Betrieb genommen werden",
openMakeSafeJob: "Sicherungsauftrag öffnen",
startInspection: "Inspektion starten",
openInspection: "Öffnen Sie die Inspektion",
createJobsFromFindings: "Erstellen Sie Arbeitsaufträge aus Ergebnissen",
waiveAndReturn: "Verzicht und Wiederinbetriebnahme",
putIntoService: "In Betrieb nehmen",
returnToService: "Wieder in Betrieb",
cancel: "Abbrechen",
cancelCommissioningTitle: "Inbetriebnahme abbrechen?",
cancelCommissioningBody: "Der Fall wird als aufgegeben geschlossen. Die Inspektion und etwaige Arbeitsaufträge bleiben als Aufzeichnungen erhalten.",
keepGoing: "Weitermachen",
cancelCommissioning: "Inbetriebnahme abbrechen",
commission: "In Betrieb nehmen",
recommission: "Wieder in Betrieb nehmen",
unarchived: "Anlage aus dem Archiv geholt",
archived: "Anlage archiviert",
statusUpdateFailedTitle: "Anlagenstatus kann nicht aktualisiert werden",
onlyAdminRestoreTitle: "Nur ein Administrator kann eine ausgemusterte Anlage wiederherstellen",
onlyAdminRestoreBody: "Bitten Sie einen Admin des Arbeitsbereichs, sie wiederherzustellen.",
restoreFromRetiredTitle: "Ausgemusterte Anlage wiederherstellen?",
restoreFromRetiredBody: "Der Datensatz wird als außer Betrieb erneut geöffnet. Führen Sie eine erneute Inbetriebnahme durch – eine Inspektion und anschließend alle daraus resultierenden Arbeitsaufträge –, um es wieder in Betrieb zu nehmen.",
restore: "Wiederherstellen",
restoredOutOfService: "Wiederhergestellt – bis zur Wiederinbetriebnahme außer Betrieb",
restoreFailedTitle: "Die Anlage konnte nicht wiederhergestellt werden",
moveFailedTitle: "Die Anlage konnte nicht verschoben werden",
moveFailedBody: "Der Umzug konnte nicht gespeichert werden.",
makeSafeRaised: "Sicherungsauftrag erstellt – die Anlage wird außer Betrieb genommen, sobald er verifiziert ist",
outOfService: "Außer Betrieb",
decommissionFailedTitle: "Diese Anlage konnte nicht außer Betrieb genommen werden",
retired: "Ausgemustert",
retireFailedTitle: "Diese Anlage konnte nicht ausgemustert werden",
returnWaiverTitle: "Wiederinbetriebnahme mit ungelösten Feststellungen",
returnWaiverMessage: "Sagen Sie, warum die Anlage ohne einen Arbeitsauftrag für das, was bei der Inspektion festgestellt wurde, wieder in Betrieb genommen werden kann. Dies steht auf dem Zertifikat.",
returnWaiverPlaceholder: "z.B. Nur kosmetisch; für den Sommerstillstand geplant.",
returnToServiceConfirm: "Wiederinbetriebnahme",
},
errors: {
generic: "Fehler",
updateFailed: "Aktualisierung fehlgeschlagen.",
deleteAssetFailed: "Anlage konnte nicht gelöscht werden.",
saveDetailsFailed: "Anlagendetails konnten nicht gespeichert werden.",
removeAccessFailedTitle: "Der Zugriff konnte nicht entfernt werden",
removeAccessBody: "Zugriff auf den gemeinsamen Arbeitsbereich für {{name}} entfernen? Die Person sieht diese Anlage dann nicht mehr als geteilt.",
removeAccessDefaultName: "diesen Kontakt",
removeAccessTitle: "Zugriff entfernen",
remove: "Entfernen",
couldNotSaveDetailsTitle: "Anlagendetails konnten nicht gespeichert werden",
syncFailed: "Synchronisierung fehlgeschlagen.",
},
deleteAsset: {
cannotDeleteTitle: "Kann noch nicht gelöscht werden",
cannotDeleteBody: "Für diese Anlage sind noch offene Arbeiten vorhanden:\n• Offene Inspektionen: {{openInspections}}\n• Offene Aufträge: {{openJobs}}\n• Aktive Zeitpläne: {{openSchedules}}\n\nDiese zuerst schließen/abschließen, dann ist Löschen verfügbar.",
confirmWebTitle: "Anlage löschen?\n\nDies kann nicht rückgängig gemacht werden.",
confirmTitle: "Anlage löschen",
confirmBody: "Sind Sie sicher? Dies kann nicht rückgängig gemacht werden.",
cancel: "Abbrechen",
delete: "Löschen",
},
cancelledSectionLabel: "Abgebrochen",
readiness: {
complianceHeadline: "Konformität – {{posture}}",
complianceDefaultAction: "Überprüfen Sie Konformitätssignale",
inspectionOverdue: "Inspektion überfällig",
inspectionDueOn: "Inspektion fällig {{date}}",
completeOverdueInspection: "Schließen Sie die überfällige Inspektion ab",
prepareAndComplete: "Vorbereiten und termingerecht abschließen",
foundationRunInspection: "Führen Sie eine Inspektion durch, um erste Zustandssignale zu erhalten",
foundationLastInspectedAgo: "Zuletzt geprüft vor {{months}} Mon. – auffrischen",
foundationRecentLast_one: "{{count}} aktuell · zuletzt {{date}}",
foundationRecentLast_other: "{{count}} aktuell · zuletzt {{date}}",
contactsLabel: "Kontakte",
contactsLinked_one: "{{count}} verknüpft · Zum Verwalten tippen",
contactsLinked_other: "{{count}} verknüpft · Zum Verwalten tippen",
contactsAddRecipient: "Fügen Sie einen Besitzer oder Berichtsempfänger hinzu",
documentsLabel: "Dokumente",
documentsAttached_one: "{{count}} Datei angehängt",
documentsAttached_other: "{{count}} Dateien angehängt",
documentsUpload: "Konformitäts- und Garantiedateien hochladen",
relationshipsLabel: "Beziehungen",
relationshipsLinkedReach_one: "{{count}} verknüpft · Reichweite {{reach}}",
relationshipsLinkedReach_other: "{{count}} verknüpft · Reichweite {{reach}}",
relationshipsMap: "Vor- und nachgelagerte Anlagen erfassen",
evidenceLabel: "Nachweis",
},
evidenceStatus: {
loadingText: "Gesundheits-, Konformitäts- und Risikonachweise werden geladen…",
failedText: "Gesundheits-, Konformitäts- und Risikonachweise konnten nicht geladen werden.",
loadingSub: "Scores werden erst angezeigt, wenn alle erforderlichen Anlagendatensätze verfügbar sind.",
failedSub: "Zum Aktualisieren ziehen. Die Ergebnisse werden ausgeblendet, bis die fehlenden Datensätze abgerufen werden können.",
},
conditionAccordionTitle: "Gesundheit, Konformität und Risiko (vollständige Aufschlüsselung)",
conditionAccordionSummary: "Werte, Einflussfaktoren und ausführliche Bereiche – aufklappen, wenn Sie das Gesamtbild brauchen.",
kpi: {
labelHealth: "Gesundheit",
labelRisk: "Risiko",
labelCompliance: "Konformität",
labelOpenJobs: "Offene Aufträge",
labelRecent: "Kürzlich",
labelNextDue: "Nächster Fälligkeitstermin",
labelDocuments: "Dokumente",
labelFiles: "Dateien",
labelQuotes: "Angebote",
labelLinkedJobs: "Verknüpfte Arbeitsaufträge",
},
fab: {
shareAsset: "Anlage teilen",
shareAssetTooltip: "Lassen Sie jemanden Probleme mit dieser Anlage melden",
shareAssetTooltipAccessOnly: "Einem Kontakt Zugriff auf diese Anlage geben",
shareAssetDescription: "Geben Sie einem Kontakt Zugriff auf diese Anlage oder öffnen Sie die öffentliche QR-Meldung, damit Probleme bei Ihnen ankommen, ohne dass die meldende Person ein Konto braucht.",
reportIssue: "Problem melden",
reportIssueTooltip: "Ein Problem mit dieser Anlage melden",
reportIssueDescription: "Öffnen Sie eine Problembeschreibung, in der Anlage, Standort und meldende Person bereits eingetragen sind.",
inspectNow: "Jetzt prüfen",
inspectNowTooltip: "Starten Sie eine Inspektion für diese Anlage",
inspectNowDescription: "Erfassen Sie Zustand, Messwerte, Fotos und Unterschriften mithilfe der aktiven Checkliste der Anlage.",
addJob: "Auftrag hinzufügen",
addJobTooltip: "Einen Auftrag für diese Anlage erstellen",
addJobDescription: "Beauftragen Sie Wartung, Reparatur oder planmäßigen Service. Anlage, Standort und Ergebnisse der letzten Inspektion werden vorab ausgefüllt.",
recordReading: "Messwert erfassen",
recordReadingTooltip: "Erfassen Sie einen Zählerstand für diese Anlage",
recordReadingDescription: "Geben Sie die Zahl auf dem Zähler ein – Meilen, Stunden, Zyklen. Wartungspläne, die nach Nutzung zählen, rechnen ab dem letzten Messwert.",
addMaintenancePlan: "Wartungsplan hinzufügen",
addMaintenancePlanTooltip: "Planen Sie wiederkehrende Arbeiten",
addMaintenancePlanDescription: "Ein Service, Test oder eine Inspektion, die sich wiederholt – nach Datum, nach Zählerstand oder je nachdem, was zuerst eintritt. Die Arbeit wird automatisch angelegt, sobald sie fällig ist.",
addDocument: "Dokument hinzufügen",
addDocumentTooltip: "Hängen Sie ein Dokument an diese Anlage an",
addDocumentDescription: "Laden Sie Handbücher, Garantien, Zertifikate, Zeichnungen oder Konformitätsnachweise hoch. Sie werden automatisch dieser Anlage zugeordnet.",
addKnowledge: "Wissen hinzufügen",
addKnowledgeTooltip: "Schreiben Sie einen Wissensartikel für diese Anlage",
addKnowledgeDescription: "Erfassen Sie Know-how, Verfahren oder Notizen als Wissensartikel – durchsuchbar und gemeinsam mit dieser Anlage nutzbar.",
moveAsset: "Anlage verschieben",
moveAssetTooltip: "Erfassen Sie, dass diese Anlage an einem neuen Ort ist",
moveAssetDescription: "Sagt, WARUM und WANN sich die Position geändert hat, sodass sich eine echte Bewegung anders liest als eine Korrektur im Verlauf.",
relateAsset: "Anlage verknüpfen",
relateAssetTooltip: "Verknüpfen Sie diese Anlage mit einer anderen in Ihrem Register",
relateAssetDescription: "Erstellen Sie Eltern-Kind-, Komponenten- oder Peer-Beziehungen. Risiken und Aktivitäten breiten sich über die verbundenen Anlagen aus.",
contacts: "Kontakte",
createContact: "Kontakt erstellen",
viewContactsTooltip: "Mit dieser Anlage verknüpfte Kontakte anzeigen",
addContactTooltip: "Fügen Sie einen mit dieser Anlage verknüpften Kontakt hinzu",
contactsLinkedDescription: "Eigentümer, Betreiber, Techniker und Stakeholder, die mit dieser Anlage verbunden sind.",
addContactDescription: "Erfassen Sie einen Eigentümer, Betreiber, Techniker, Auftragnehmer oder Interessenvertreter für diese Anlage.",
addContact: "Kontakt hinzufügen",
addContactTooltip2: "Verknüpfen Sie einen Kontakt mit dieser Anlage",
conditionReport: "Asset 360",
conditionReportTooltip: "Asset 360: ein Bericht für den Leser, den Sie wählen. Verbraucht Credits.",
conditionReportDescription: "Ein generiertes Briefing mit Zustandstrends, wiederkehrenden Fehlern, aktuellen Kosten, Konformitätsstatus und empfohlenen nächsten Maßnahmen.",
guideMe: "Anleitung",
guideMeTooltip: "Führen Sie mich durch eine Aufgabe für diese Anlage",
guideMeDescription: "Schritt-für-Schritt-Anleitung: Planen Sie wiederkehrende Prüfungen, richten Sie einen Wartungsplan ein, zeichnen Sie eine Messung auf, fügen Sie ein Dokument oder Wissen hinzu, verschieben Sie es und mehr.",
},
guide: {
proactiveLabel: "Planen Sie wiederkehrende Prüfungen",
proactiveHint: "Eine Inspektion, die sich wiederholt, sodass Verschleiß erkannt wird, bevor etwas ausfällt.",
maintenancePlanLabel: "Richten Sie einen Wartungsplan ein",
maintenancePlanHint: "Arbeit, die nach Datum, nach Zähler oder je nachdem, was zuerst eintritt, zurückkommt.",
meterReadingLabel: "Zählerstand erfassen",
meterReadingHint: "Meilen, Stunden oder Zyklen, damit Pläne, die nach Nutzung zählen, pünktlich bleiben.",
raiseRequestLabel: "Ein Problem melden",
raiseRequestHint: "Protokollieren Sie ein Problem und wählen Sie aus, was als nächstes passieren soll.",
addDocumentLabel: "Ein Dokument hinzufügen",
addDocumentHint: "Zertifikate, Garantien und Handbücher, mit Ablauferinnerungen.",
knowledgeLabel: "Wissen hinzufügen",
knowledgeHint: "Eine Anleitung, FAQ oder ein Hinweis, den Ihr Team später finden kann.",
moveLabel: "Standortwechsel erfassen",
moveHint: "Wo es sich jetzt befindet und ob es verschoben wurde oder falsch aufgezeichnet wurde.",
teamLabel: "Verschieben Sie es in ein Team",
teamHint: "Damit jeder im Team daran arbeiten kann.",
relateLabel: "Verknüpfen Sie eine zugehörige Anlage",
relateHint: "Ein übergeordnetes Element, ein Teil oder etwas, von dem es abhängt.",
publicIntakeLabel: "Meldungen per QR-Code für alle erlauben",
publicIntakeHint: "Öffentliche Meldung: Ein Problem durch Scannen eines Codes melden, ohne Anmeldung.",
aiReportLabel: "Asset-360-Bericht vorbereiten",
aiReportHint: "Die KI schreibt ihn aus allem, was über diese Anlage bekannt ist, für den Leser Ihrer Wahl. Credits werden erst nach dem Schreiben verbraucht.",
decommissionLabel: "Nehmen Sie es außer Betrieb",
decommissionHint: "Außerbetriebnahme mit Grund und, falls nötig, einem Sicherungsauftrag.",
commissionLabelPlanned: "Nehmen Sie es in Betrieb",
commissionLabelOther: "Nehmen Sie es wieder in Betrieb",
commissionHint: "Eine Inbetriebnahmeinspektion, Aufträge aus ihren Ergebnissen, dann wieder in Betrieb.",
retireLabel: "Ausmustern",
retireHint: "Schließen Sie den Datensatz endgültig, wobei die Entsorgung hinterlegt ist.",
},
copilot: {
openRequests: "Offene Anfragen",
openInspections: "Offene Prüfungen",
openJobs: "Offene Aufträge",
reviewOpenWork: "Offene Arbeit prüfen",
reviewAsset: "Anlage prüfen",
suggestNextSteps: "Nächste Schritte vorschlagen",
automateRenewalWork: "Automatisieren Sie Erneuerungsarbeiten",
},
overflow: {
archive: "Archivieren",
unarchive: "Aus dem Archiv holen",
changeStatus: "Status ändern",
decommission: "Außer Betrieb nehmen",
restoreFromRetired: "Ausmusterung aufheben",
retireAsset: "Anlage ausmustern",
delete: "Löschen",
deleteHelpText: "„Löschen“ ist erst verfügbar, nachdem alle Inspektionen, Arbeitsaufträge und Zeitpläne geschlossen/abgeschlossen wurden.",
},
refineWork: {
title: "Arbeit filtern",
status: "Status",
all: "Alle",
scheduled: "Geplant",
active: "Aktiv",
completed: "Abgeschlossen",
},
sections: {
esg: "ESG",
overview: "Übersicht",
details: "Details",
maintenance: "Wartung",
work: "Arbeit",
reports: "Berichte",
documents: "Dokumente",
relationships: "Beziehungen",
knowledge: "Wissen",
activity: "Aktivität",
health: "Gesundheit",
particulars: "Einzelheiten",
contacts: "Kontakte",
linkedAssets: "Verknüpfte Anlagen",
labelWithCount: "{{label}}, {{count}}",
articles: "Artikel",
},
},
  advancedReport: {
    shareFailedTitle: "Bericht konnte nicht gespeichert werden",
    shareGenerated: "Von der KI erstellt am {{date}}. Prüfen Sie ihn, bevor Sie sich darauf verlassen.",
    shareTitle: "Anlagenbericht: {{name}}",
    pdfDocType: "Anlagenbericht",
    insightTitle: "Zusammenfassung des Anlagenberichts",
    heroSub: "Die KI schreibt einen Bericht aus Inspektionen, Aufträgen, Dokumenten, Risiko und Wartungsverlauf dieser Anlage.",
    heroTitle: "Anlagenbericht",
    fallbackTitle: "Anlagenbericht",
    metaKind: "KI-Bericht",
    summaryPlaceholder: "Tippen Sie auf Bericht erstellen, um Risiko, Zustand, Compliance und nächste Schritte dieser Anlage zu sehen.",
    actionGenerate: "Erstellen Sie den Anlagenbericht.",
    generateFailedTitle: "Der Anlagenbericht wurde nicht erstellt",
    analysisHistory: "Verlauf",
    sourceGenerated: "Von der KI erstellt",
    sourceSetup: "Noch nicht erstellt",
  },
  createForm: {
    checkout: {
      syncingBody: "Die Zahlung war erfolgreich. Warten Sie einen Moment und tippen Sie erneut auf Anlage anlegen.",
      syncingTitle: "Ihr Tarif ist fast bereit",
      cancelledBody: "Ihre Angaben zur Anlage bleiben erhalten. Tippen Sie auf Anlage anlegen, wenn Sie bereit sind.",
      notStartedTitle: "Tarif nicht gestartet",
      cancelledTitle: "Bezahlung abgebrochen",
      openFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      openFailedTitle: "Bezahlung konnte nicht geöffnet werden",
    },
    save: {
      saveWithoutPhotos: "Ohne Fotos anlegen",
      cancel: "Abbrechen",
      photoUploadFailedBody: "Anlage ohne Fotos anlegen? Sie können sie später über Bearbeiten hinzufügen.",
      photoUploadFailedTitle: "Fotos konnten nicht hochgeladen werden",
      photosFailedBody: "Die Fotos konnten nicht hochgeladen werden. Öffnen Sie die Anlage und tippen Sie auf Bearbeiten, um sie hinzuzufügen.",
      photosFailedTitle: "Anlage ohne Fotos angelegt",
      duplicateDecisionBody: "Ihre Entscheidung zum möglichen Duplikat wurde nicht gespeichert. Sie können sie später in der Anlage verknüpfen.",
      duplicateDecisionTitle: "Anlage angelegt",
      partialRelBody: "Nicht gespeicherte Verknüpfungen mit anderen Anlagen: {{n}}. Fügen Sie sie im Bereich Beziehungen der Anlage erneut hinzu.",
      partialRelTitle: "Anlage angelegt, einige Verknüpfungen nicht gespeichert",
      qrNotLinkedBody: "Öffnen Sie die Anlage und verknüpfen Sie das Etikett im QR-Bereich.",
      qrNotLinkedTitle: "Anlage angelegt, QR-Etikett nicht verknüpft",
      failedBody: "Prüfen Sie Ihre Verbindung und tippen Sie erneut auf Anlage anlegen. Ihre Angaben bleiben erhalten.",
      failedTitle: "Anlage konnte nicht angelegt werden",
      nameRequiredBody: "Geben Sie der Anlage einen Namen und tippen Sie dann auf Anlage anlegen.",
      nameRequiredTitle: "Namen eingeben",
      signInBody: "Melden Sie sich erneut an und tippen Sie dann auf Anlage anlegen.",
      signInTitle: "Erneut anmelden",
    },
    duplicates: {
      failedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      failedTitle: "Duplikate konnten nicht geprüft werden",
      foundTitle: "Das könnte dieselbe Anlage sein",
      noneBody: "Nichts anderes passt zu diesem Namen oder dieser ID.",
      noneTitle: "Keine Duplikate gefunden",
      needNameBody: "Geben Sie den Namen der Anlage ein und suchen Sie dann nach Duplikaten.",
      needNameTitle: "Zuerst einen Namen eingeben",
    },
    idHint: "Die Nummer auf dem Typenschild oder Etikett. Damit finden Sie die Anlage per Scan.",
    useIdFromPhoto: "„{{id}}“ als ID oder Seriennummer verwenden",
    readPlateTitle: "Typenschild lesen",
    externalIdOptional: "{{label}} (optional)",
    unnamed: "Unbenannte Anlage",
    dictation: {
      listening: "Hört zu…",
      heard: "Gehört: {{text}}",
      finishing: "Wird abgeschlossen…",
      inserting: "Ihr Diktat wird eingefügt…",
      stopA11y: "Diktat beenden",
      dictateA11y: "Namen diktieren",
      stop: "Stopp",
      dictate: "Diktieren",
    },
    footer: {
      creating: "Wird angelegt…",
      create: "Anlage anlegen",
      needName: "Geben Sie zuerst einen Namen ein",
      needsPlan: "Für das nächste Asset ist ein kostenpflichtiger Plan nötig",
      needsPlanHint: "Ihre Eingaben bleiben erhalten, während Sie wählen.",
      ready: "Bereit zum Anlegen",
    },
    sectionWhy: {
      details: "Fügen Sie Hersteller, Modell und Wichtigkeit hinzu. Das geht auch später.",
      identify: "Fügen Sie ein Foto und die Seriennummer oder den Barcode hinzu, damit man es vor Ort scannen kann.",
      location: "Fügen Sie Standort oder Adresse hinzu, damit man es findet.",
      basics: "Geben Sie einen Namen ein und wählen Sie einen Typ. Mehr brauchen Sie zum Anlegen nicht.",
    },
    location: {
      locationOptional: "Standort (optional)",
      propertyAddress: "Adresse der Immobilie",
      siteSelected: "Standort · {{name}}",
      siteLabel: "Standort",
      noSiteBody: "Kein Standort ist in Ihrer Nähe. Wählen Sie einen aus der Liste oder lassen Sie das Feld leer.",
      noSiteTitle: "Kein Standort in der Nähe",
      noAddressBody: "Ihr Standort wurde gefunden, aber keine Adresse. Geben Sie die Adresse ein.",
      noAddressTitle: "Keine Adresse gefunden",
    },
    photos: {
      summaryCount: "{{used}} von {{max}}",
      countFull: "{{max}} von {{max}}. Mehr geht nicht.",
      countMore: "{{used}} von {{max}}. Sie können noch {{left}} hinzufügen.",
      galleryA11y: "Aus Ihren Fotos wählen. {{used}} von {{max}} verwendet.",
      cameraA11y: "Foto aufnehmen. {{used}} von {{max}} verwendet.",
      mainFullA11y: "Hauptfoto. {{max}} von {{max}} Fotos hinzugefügt.",
      mainA11y: "Hauptfoto. {{used}} von {{max}} hinzugefügt. Tippen, um ein weiteres hinzuzufügen.",
      addA11y: "Fotos hinzufügen, bis zu {{max}}",
      cameraBody: "Erlauben Sie AssetWRX in den Telefoneinstellungen den Kamerazugriff und versuchen Sie es erneut.",
      libraryBody: "Erlauben Sie AssetWRX in den Telefoneinstellungen den Zugriff auf Ihre Fotos und versuchen Sie es erneut.",
      permissionTitle: "Zugriff erlauben",
      limitBody: "Sie können bis zu {{max}} Fotos hinzufügen.",
      limitTitle: "Fotolimit erreicht",
    },
    suggestion: {
      useA11y: "{{label}} als Typ übernehmen",
      dismiss: "Nein danke",
      use: "Übernehmen",
      fromPhoto: "Laut Foto: {{label}}",
      looksLike: "Sieht aus wie: {{label}}",
    },
    photoIdentify: {
      noMatchBody: "Wir konnten auf dem Foto nichts erkennen. Versuchen Sie ein schärferes Foto oder wählen Sie den Typ selbst.",
      noMatchTitle: "Keine Übereinstimmung",
      noCreditsBody: "Ihr Arbeitsbereich hat keine KI-Guthaben mehr. Wählen Sie den Typ selbst.",
      failedBody: "Versuchen Sie es erneut oder wählen Sie den Typ selbst.",
      failedTitle: "Foto konnte nicht gelesen werden",
      a11y: "Anlagentyp anhand des Fotos erkennen",
      busy: "Foto wird geprüft…",
      button: "Typ anhand des Fotos erkennen",
    },
    leaveGuard: {
      keep: "Weiter bearbeiten",
      leave: "Verlassen",
      message: "Ihre neue Anlage ist noch nicht gespeichert. Verlassen und verwerfen?",
    },
    namePlaceholder: {
      other: "Zum Beispiel: Bühnenbeleuchtung",
      equipment: "Zum Beispiel: Heizkessel 3",
      property: "z. B. Eichenstraße 14",
      car: "Zum Beispiel: Toyota Camry 2024",
    },
    typeDesc: {
      other: "Alles andere",
      equipment: "Maschinen und Werkzeuge",
      property: "Gebäude und Grundstücke",
      car: "Fahrzeuge und Flotten",
    },
  },
  lifecycleBanner: {
    plannedBody: "Tippen Sie auf In Betrieb nehmen: zuerst eine Inspektion, dann die gefundenen Aufträge.",
    decommissionedBody: "Die Zeitpläne sind pausiert. Tippen Sie auf Wieder in Betrieb nehmen, um es zurückzuholen.",
    archivedBody: "Sie können es weiter ansehen und bearbeiten. Um Inspektionen oder Aufträge hinzuzufügen, holen Sie es über das Menü ⋯ aus dem Archiv.",
    retiredBody: "Der Verlauf bleibt lesbar, aber es nimmt keine neuen Inspektionen oder Aufträge mehr an.",
    since: "Seit {{date}}",
  },
  shareReview: {
    rights: {
      view: "Darf diese Anlage sehen",
      viewBody: "Sie sehen es in ihrem eigenen Konto.",
      workBody: "Sie melden Probleme und verfolgen sie bis zur Erledigung.",
      jobs: "Aufträge sehen",
      jobsBody: "Aufträge zu dieser Anlage und ihr Stand.",
      inspections: "Inspektionen sehen",
      inspectionsBody: "Inspektionsergebnisse zu dieser Anlage.",
      documents: "Dokumente öffnen",
      documentsBody: "Dokumente bleiben privat, bis Sie dies einschalten.",
    },
    confirmLink: "Kontakt verknüpfen",
    confirmShare: "Teilen",
    selectContact: "Wählen Sie zuerst einen Kontakt",
    batchHint: "Ausgewählte Kontakte: {{n}}. Der Zugriff unten gilt für alle.",
  },
  editForm: {
    photoCountNone: "0 von {{max}} Fotos. Alle optional.",
    photosHintA11y: "Optional. Bis zu {{max}} Fotos.",
    saveFailedBody: "Prüfen Sie Ihre Verbindung und tippen Sie erneut auf Speichern. Ihre Änderungen bleiben erhalten.",
    saveFailedTitle: "Änderungen konnten nicht gespeichert werden",
    saved: "Änderungen gespeichert.",
    partialRelTitle: "Änderungen gespeichert, einige Verknüpfungen nicht",
    uploadFailedBody: "Prüfen Sie Ihre Verbindung und tippen Sie erneut auf Speichern. Ihre Änderungen bleiben erhalten.",
    signInBody: "Melden Sie sich erneut an und tippen Sie dann auf Speichern.",
    nameRequiredBody: "Geben Sie der Anlage einen Namen und tippen Sie dann auf Speichern.",
    linkFailedTitle: "Duplikat konnte nicht markiert werden",
    linkedBody: "Beide Anlagen zeigen jetzt die Verknüpfung, damit Sie sie später prüfen können.",
    linkedTitle: "Als mögliches Duplikat markiert",
    openExisting: "Die andere Anlage öffnen",
    improve: "Mit KI verbessern",
    improving: "Wird verbessert…",
    improveRationale: "Lesen Sie die neuen Notizen und tippen Sie auf Übernehmen, um sie zu behalten.",
    improveFailedBody: "Versuchen Sie es erneut oder behalten Sie Ihren Text.",
    improveFailedTitle: "Beschreibung konnte nicht verbessert werden",
    improveNeedsDraftBody: "Tippen oder diktieren Sie eine kurze Beschreibung und tippen Sie dann auf Mit KI verbessern.",
    improveNeedsDraftTitle: "Schreiben Sie zuerst ein paar Worte",
    improvedTitle: "Verbesserte Notizen zur Anlage",
    notFound: "Diese Anlage wurde nicht gefunden. Sie wurde vielleicht gelöscht, oder Sie haben keinen Zugriff.",
    loadFailed: "Diese Anlage konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und tippen Sie auf Erneut versuchen.",
  },
  sharedView: {
    facts: {
      nextVisit: "Nächster Besuch: {{date}}",
      jobs: "Aufträge: {{n}}",
    },
    requests: {
      title: "Ihre Anfragen",
      you: "Sie: {{text}}",
      photo: "Foto",
      unread: "Neue Antwort",
    },
    thread: {
      title: "Anfrage",
      loading: "Anfrage wird geöffnet…",
      loadFailedTitle: "Anfrage konnte nicht geöffnet werden",
      loadFailed: "Prüfen Sie Ihre Verbindung und tippen Sie auf Erneut versuchen.",
      showProgress: "Fortschritt und Ihre Möglichkeiten anzeigen",
      hideProgress: "Fortschritt ausblenden",
    },
    records: {
      documents: "Dokumente",
      jobs: "Aufträge",
      inspections: "Inspektionen",
      no_documents: "Zu dieser Anlage gibt es noch keine Dokumente.",
      no_jobs: "Zu dieser Anlage gibt es noch keine Aufträge.",
      no_inspections: "Zu dieser Anlage gibt es noch keine Inspektionen.",
      loadFailed: "Konnte nicht geladen werden. Zum Aktualisieren nach unten ziehen.",
      openDocument: "{{title}} öffnen",
      expires: "Läuft ab am {{date}}",
      due: "Fällig am {{date}}",
      done: "Erledigt am {{date}}",
      inspection: "Inspektion",
      inspectionNumbered: "Inspektion {{number}}",
      issues: "Mängel: {{n}}",
    },
    raiseRequest: "Problem melden",
    sharedWithYou: "Mit Ihnen geteilt",
    kpiRelatedJobs: "Zugehörige Aufträge",
    none: "Keine",
    kpiNextInspection: "Nächste Inspektion",
    kpiStatus: "Status",
    permDocuments: "Dokumente",
    permInspections: "Inspektionen",
    permJobs: "Aufträge",
    accept: "Annehmen",
    working: "Wird bearbeitet…",
    invitation: "Einladung",
    thisAsset: "Diese Anlage",
    tryAgain: "Erneut versuchen",
    checking: "Wird geprüft…",
    sharedReadOnly: "Geteilt · nur lesen",
    readOnly: "Nur lesen",
    refreshFailedBody: "Prüfen Sie Ihre Verbindung und tippen Sie auf Erneut versuchen.",
    refreshFailedTitle: "Aktualisieren fehlgeschlagen",
    stillNoAccessBody: "Ihr Konto ist noch nicht mit dieser Freigabe verknüpft. Nehmen Sie die Einladung in Ihrer E-Mail an oder bitten Sie die teilende Person, erneut mit Ihrer E-Mail-Adresse zu teilen.",
    stillNoAccessTitle: "Weiterhin kein Zugriff",
    sharedAccess: "Mit Ihnen geteilt",
    pendingAccess: "Wartet auf Ihre Annahme",
    job: "Auftrag",
    linkedAsset: "Verknüpfte Anlage",
    theirWorkspace: "seinem Arbeitsbereich",
    aTeamMember: "Ein Teammitglied",
    checkFailed: "Ihr Zugriff auf diese Anlage konnte nicht geprüft werden. Prüfen Sie Ihre Verbindung und tippen Sie auf Erneut versuchen.",
    notScheduled: "Nicht geplant",
    accessTimedOut: "Die Prüfung Ihres Zugriffs hat zu lange gedauert. Prüfen Sie Ihre Verbindung und tippen Sie auf Erneut versuchen.",
  },
retireConfirmWord: "AUSMUSTERN",
knowledgeKind: {
  updatedAgo: "aktualisiert {{when}}",
  someone: "Ein Teammitglied",
  pinnedPrefix: "Angeheftet",
  link: "Externer Link",
  howto: "Anleitung",
  note: "Notiz",
  faq: "FAQ",
  file: "Datei",
},
knowledgeTab: {
  searchPlaceholder: "Wissen durchsuchen…",
  uploadDocument: "Dokument hochladen",
  noMatchingArticles: "Keine passenden Artikel",
  noArticlesYet: "Noch keine Artikel",
  noMatchHint: "Keine Artikel passen zur aktuellen Suche oder zu den Filtern.",
  emptyManageHint: "Fügen Sie Anleitungen, Links, FAQs oder Dateien hinzu, damit Ihr Team sie im Einsatz findet.",
  emptyReadHint: "Nichts passt zu Ihrer Suche, oder es wurde noch nichts veröffentlicht.",
  loadErrorWithReason: "{{error}}. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  loadErrorHint: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  newArticle: "Neuer Artikel",
  editArticle: "Artikel bearbeiten",
  exactMatch: "Exakte Übereinstimmung",
  anyMatchCommaSeparated: "Beliebige Übereinstimmung, durch Kommas getrennt",
  commaSeparated: "Durch Kommas getrennt",
  polishedDescription: "Überarbeitete Beschreibung",
  polishedContent: "Überarbeiteter Inhalt",
  polishFailedTitle: "Überarbeitung nicht möglich",
  polishUnavailable: "Die Überarbeitung ist gerade nicht möglich.",
  polishReview: "Prüfen Sie den überarbeiteten Text, bevor Sie ihn übernehmen.",
  polishDescriptionFailed: "Die Beschreibung konnte nicht überarbeitet werden.",
  polishContentFailed: "Der Inhalt konnte nicht überarbeitet werden.",
  titleRequiredTitle: "Titel erforderlich",
  titleRequiredBody: "Bitte geben Sie einen Titel ein.",
  errorTitle: "Fehler",
  saveFailed: "Speichern fehlgeschlagen",
  uploadFailedTitle: "Hochladen fehlgeschlagen",
  uploadFailedBody: "Die Datei konnte nicht hochgeladen werden",
  deleteTitle: "Artikel löschen",
  deleteBody: "„{{title}}“ entfernen?",
  deleteFailed: "Löschen fehlgeschlagen",
  cancel: "Abbrechen",
  delete: "Löschen",
},
needsAttention: {
  requestsAwaitingApproval_one: "{{count}} Anfrage wartet auf Freigabe",
  requestsAwaitingApproval_other: "{{count}} Anfragen warten auf Freigabe",
  requestsAwaitingWork_one: "{{count}} freigegebene Anfrage braucht Arbeit",
  requestsAwaitingWork_other: "{{count}} freigegebene Anfragen brauchen Arbeit",
  overdueJobs_one: "{{count}} überfälliger Auftrag",
  overdueJobs_other: "{{count}} überfällige Aufträge",
  inspectionsAwaitingApproval_one: "{{count}} Inspektion wartet auf Freigabe",
  inspectionsAwaitingApproval_other: "{{count}} Inspektionen warten auf Freigabe",
  expiredDocuments_one: "{{count}} abgelaufenes Dokument",
  expiredDocuments_other: "{{count}} abgelaufene Dokumente",
  expiringSoonDocuments_one: "{{count}} Dokument läuft bald ab",
  expiringSoonDocuments_other: "{{count}} Dokumente laufen bald ab",
  overdueSchedules_one: "{{count}} überfällige geplante Inspektion",
  overdueSchedules_other: "{{count}} überfällige geplante Inspektionen",
  unresolvedFindings_one: "{{count}} offener Inspektionsbefund",
  unresolvedFindings_other: "{{count}} offene Inspektionsbefunde",
  pendingApprovals_one: "{{count}} geteilter Bericht wartet auf Abnahme",
  pendingApprovals_other: "{{count}} geteilte Berichte warten auf Abnahme",
  openHighUrgencyJobs_one: "{{count}} offener dringender Auftrag",
  openHighUrgencyJobs_other: "{{count}} offene dringende Aufträge",
  failedInspections_one: "Letzte Inspektion hat Mängel festgestellt",
  failedInspections_other: "{{count}} Inspektionen mit Mängeln",
  detail: {
    approveOrDecline: "Freigeben oder ablehnen",
    createJobOrInspection: "Auftrag oder Inspektion anlegen",
    progressOrReschedule: "Arbeit fortsetzen oder neu planen",
    reviewAndApprove: "Prüfen und freigeben",
    renewOrReplace: "Dateien erneuern oder ersetzen",
    planRenewal: "Erneuerung planen",
  },
},
conditionTrend: {
  loading: "Abgeschlossene Inspektionen und Zustandsbewertungen werden geladen…",
  loadFailed: "Abgeschlossene Inspektionen und Zustandsbewertungen konnten nicht geladen werden. Zum Aktualisieren ziehen und erneut versuchen.",
  emptyNoInspections: "Der Zustandsverlauf erscheint nach der ersten bewerteten Inspektion.",
  emptyUnrated_one: "{{count}} abgeschlossene Inspektion hat keine Zustandsbewertung von 1–5, daher gibt es noch keinen Verlauf.",
  emptyUnrated_other: "{{count}} abgeschlossene Inspektionen haben keine Zustandsbewertung von 1–5, daher gibt es noch keinen Verlauf.",
  band: { good: "Gut", fair: "Mittel", poor: "Schlecht" },
  latest: "{{percent}} % · {{band}}",
  readingsA11y: "Zustandswerte, vom ältesten zum neuesten: {{readings}}",
  readingA11y: "{{percent}} Prozent {{band}}",
  ratedInspections_one: "{{count}} bewertete Inspektion",
  ratedInspections_other: "{{count}} bewertete Inspektionen",
  oneRated: "Eine bewertete Inspektion · eine weitere zeigt den Verlauf",
  down_one: "Gesunken von {{first}} % auf {{last}} % über {{count}} Inspektion.",
  down_other: "Gesunken von {{first}} % auf {{last}} % über {{count}} Inspektionen.",
  steady_one: "Stabil bei {{last}} % über {{count}} Inspektion.",
  steady_other: "Stabil bei {{last}} % über {{count}} Inspektionen.",
  up_one: "Gestiegen von {{first}} % auf {{last}} % über {{count}} Inspektion.",
  up_other: "Gestiegen von {{first}} % auf {{last}} % über {{count}} Inspektionen.",
},
intelligenceCard: {
  state: {
    stable: "Stabil",
    watch: "Beobachten",
    deteriorating: "Verschlechtert sich",
    action_recommended: "Maßnahme empfohlen",
    critical: "Kritisch",
  },
  strength: {
    early_signal: "Frühes Signal",
    moderate_evidence: "Mäßige Belege",
    strong_evidence: "Starke Belege",
  },
  conditionScore: "Zustand {{score}}/100 · {{strength}}",
  dataQuality: "Datenqualität: {{warning}}",
  suggestedBy: "Empfohlen bis {{date}}",
  recommendation: {
    inspect_sooner: "Vor der geplanten Wartung inspizieren",
    maintenance_sooner: "Geplante Wartung vorziehen",
    review_interval: "Wartungsintervall überprüfen",
    raise_follow_up: "Folgearbeit anlegen",
    monitor: "Zählerstand erfassen, damit der Plan stimmt",
  },
  recordFailedTitle: "Das konnte nicht gespeichert werden",
  dismissFailedTitle: "Das konnte nicht verworfen werden",
  stillOpenBody: "Die Empfehlung ist noch offen. Versuchen Sie es erneut.",
},
documentSubtype: {
  label: {
    gas_safety: "Gassicherheit",
    electrical: "Elektrik",
    fire_safety: "Brandschutz",
    pat_testing: "Geräteprüfung (PAT)",
    lift: "Aufzug (LOLER)",
    legionella: "Legionellen",
    pressure_system: "Druckanlage",
    ppe: "PSA",
    vehicle_roadworthy: "Verkehrssicherheit (MOT)",
    epc: "Energieausweis (EPC)",
    manufacturer: "Hersteller",
    extended: "Erweitert",
    service_contract: "Wartungsvertrag",
    regulatory: "Behördlich",
    audit: "Prüfung",
    insurance: "Versicherung",
    manual: "Handbuch",
    drawing: "Zeichnung",
    photo: "Foto",
    report: "Bericht",
  },
  titleExample: {
    gas_safety: "z. B. Gassicherheitszertifikat",
    electrical: "z. B. Elektroinstallationsnachweis",
    fire_safety: "z. B. Brandschutz-Gefährdungsbeurteilung",
    pat_testing: "z. B. Prüfprotokoll ortsveränderlicher Geräte",
    lift: "z. B. Gründliche LOLER-Prüfung",
    legionella: "z. B. Legionellen-Gefährdungsbeurteilung",
    pressure_system: "z. B. Schriftliches Prüfprogramm",
    ppe: "z. B. PSA-Prüfprotokoll",
    vehicle_roadworthy: "z. B. MOT-Bescheinigung",
    epc: "z. B. Energieausweis",
    manufacturer: "z. B. Herstellergarantie",
    extended: "z. B. Garantieverlängerung",
    service_contract: "z. B. Jährlicher Wartungsvertrag",
    regulatory: "z. B. Behördlicher Konformitätshinweis",
    audit: "z. B. Konformitätsprüfbericht",
    insurance: "z. B. Betriebshaftpflichtversicherung",
    manual: "z. B. Bedienungsanleitung",
    drawing: "z. B. Grundriss",
    photo: "z. B. Foto zum Anlagenzustand",
    report: "z. B. Zustandsgutachten",
  },
  titleExampleByType: {
    certificate: "z. B. Gassicherheitszertifikat",
    warranty: "z. B. Herstellergarantie",
    compliance: "z. B. Versicherungspolice",
    general: "z. B. Gerätehandbuch",
  },
},
retirePreflight: {
  openCase: "Eine Inbetriebnahme oder Außerbetriebnahme läuft — erst abschließen oder abbrechen",
  openInspections_other: "{{count}} laufende Inspektionen — erst abschließen oder verwerfen",
  openInspections_one: "1 laufende Inspektion — erst abschließen oder verwerfen",
  openJobs_other: "{{count}} offene Aufträge — erst abschließen oder abbrechen",
  openJobs_one: "1 offener Auftrag — erst abschließen oder abbrechen",
},
readinessCard: {
needAttention_one: "{{count}} braucht Aufmerksamkeit",
needAttention_other: "{{count}} brauchen Aufmerksamkeit",
foundationsInPlace: "Grundlagen vorhanden",
},
documentTakeOver: {
title: "An deren Stelle validieren?",
body_one: "{{name}} hat \"{{title}}\" seit {{count}} Tag nicht validiert. Als Anlagenteam validieren? Das wird als stellvertretend erledigt vermerkt.",
body_other: "{{name}} hat \"{{title}}\" seit {{count}} Tagen nicht validiert. Als Anlagenteam validieren? Das wird als stellvertretend erledigt vermerkt.",
keepWaiting: "Weiter warten",
validate: "Validieren",
note_one: "Vom Anlagenteam stellvertretend für {{name}} validiert, nachdem {{count}} Tag lang keine Antwort kam.",
note_other: "Vom Anlagenteam stellvertretend für {{name}} validiert, nachdem {{count}} Tage lang keine Antwort kam.",
},
lifecycleCopy: {
inspectionDone: "Inspektion ✓",
inspectionInProgress: "Inspektion läuft",
inspectionNotStarted: "Inspektion nicht begonnen",
jobsVerified: "Aufträge {{verified}}/{{raised}} verifiziert",
findingsWaived_one: "{{count}} Befund mit Ausnahme",
findingsWaived_other: "{{count}} Befunde mit Ausnahme",
findingsNeedJob_one: "{{count}} Befund braucht einen Auftrag",
findingsNeedJob_other: "{{count}} Befunde brauchen einen Auftrag",
noFindings: "Keine Befunde",
retireNoNewWork: "Nimmt nie wieder neue Inspektionen oder Aufträge an. Verlauf und Dokumente bleiben lesbar.",
retireSharesRevoked_one: "{{count}} Freigabe widerrufen",
retireSharesRevoked_other: "{{count}} Freigaben widerrufen",
retireIntakeOff: "Öffentlicher Meldelink deaktiviert",
retireSchedulesCancelled_one: "{{count}} geplante Inspektion abgesagt",
retireSchedulesCancelled_other: "{{count}} geplante Inspektionen abgesagt",
retireNoLongerBilled: "Wird nicht mehr berechnet",
retireHidden: "In Listen, KPIs und Risiko ausgeblendet; unter Ausgemustert aufgeführt",
},
complianceSummary: {
recentInspections_one: "{{count}} Inspektion in den letzten 30 Tagen abgeschlossen",
recentInspections_other: "{{count}} Inspektionen in den letzten 30 Tagen abgeschlossen",
documentsValid: "Alle erfassten Konformitätsdokumente sind derzeit gültig",
noOverdueSchedules: "Keine überfälligen geplanten Inspektionen",
noOpenJobs: "Derzeit keine offenen Aufträge mit dieser Anlage verknüpft",
uploadDocuments: "Laden Sie Konformitätsdokumente (Zertifikate, Garantien oder Nachweise) für diese Anlage hoch",
renewExpired_one: "Erneuern Sie {{count}} abgelaufenes Konformitätsdokument",
renewExpired_other: "Erneuern Sie {{count}} abgelaufene Konformitätsdokumente",
planRenewals_one: "Planen Sie die Erneuerung für {{count}} bald ablaufendes Dokument",
planRenewals_other: "Planen Sie die Erneuerung für {{count}} bald ablaufende Dokumente",
establishBaseline: "Schließen Sie eine Inspektion ab, um eine überprüfbare Konformitätsgrundlage zu schaffen",
scheduleNewInspection_one: "Planen Sie eine neue Inspektion — die letzte abgeschlossene Inspektion war vor {{count}} Tag",
scheduleNewInspection_other: "Planen Sie eine neue Inspektion — die letzte abgeschlossene Inspektion war vor {{count}} Tagen",
completeOverdueSchedules_one: "Schließen Sie {{count}} überfällige geplante Inspektion ab",
completeOverdueSchedules_other: "Schließen Sie {{count}} überfällige geplante Inspektionen ab",
resolveOverdueJobs_one: "Erledigen oder verschieben Sie {{count}} überfälligen offenen Auftrag",
resolveOverdueJobs_other: "Erledigen oder verschieben Sie {{count}} überfällige offene Aufträge",
reviewUrgentJobs_one: "Prüfen Sie {{count}} offenen Auftrag mit hoher Dringlichkeit und aktualisieren Sie Status oder Fälligkeitsdatum",
reviewUrgentJobs_other: "Prüfen Sie {{count}} offene Aufträge mit hoher Dringlichkeit und aktualisieren Sie Status oder Fälligkeitsdaten",
addressFindings_one: "Bearbeiten Sie {{count}} offenen Befund aus der letzten abgeschlossenen Inspektion",
addressFindings_other: "Bearbeiten Sie {{count}} offene Befunde aus der letzten abgeschlossenen Inspektion",
followUpApprovals_one: "Haken Sie bei {{count}} ausstehenden Genehmigung nach",
followUpApprovals_other: "Haken Sie bei {{count}} ausstehenden Genehmigungen nach",
},
conditionImpacts: {
expiredDocumentsLabel_one: "Abgelaufenes Compliance-Dokument",
expiredDocumentsLabel_other: "Abgelaufene Compliance-Dokumente",
expiredDocumentsInline_one: "abgelaufenes Compliance-Dokument",
expiredDocumentsInline_other: "abgelaufene Compliance-Dokumente",
expiredDocumentsRationale_one: "{{count}} Dokument hat sein Ablaufdatum überschritten. Jedes abgelaufene Dokument senkt den Wert um bis zu 25 Punkte (insgesamt höchstens 50).",
expiredDocumentsRationale_other: "{{count}} Dokumente haben ihr Ablaufdatum überschritten. Jedes abgelaufene Dokument senkt den Wert um bis zu 25 Punkte (insgesamt höchstens 50).",
expiringDocumentsLabel_one: "Bald ablaufendes Dokument",
expiringDocumentsLabel_other: "Bald ablaufende Dokumente",
expiringDocumentsInline_one: "bald ablaufendes Dokument",
expiringDocumentsInline_other: "bald ablaufende Dokumente",
expiringDocumentsRationale_one: "{{count}} Dokument liegt im Erinnerungszeitraum vor dem Ablauf und muss verlängert werden (bis zu 8 Punkte je Dokument, max. 24).",
expiringDocumentsRationale_other: "{{count}} Dokumente liegen im Erinnerungszeitraum vor dem Ablauf und müssen verlängert werden (bis zu 8 Punkte je Dokument, max. 24).",
overdueSchedulesLabel_one: "Überfällige geplante Inspektion",
overdueSchedulesLabel_other: "Überfällige geplante Inspektionen",
overdueSchedulesInline_one: "überfällige geplante Inspektion",
overdueSchedulesInline_other: "überfällige geplante Inspektionen",
overdueSchedulesRationale_one: "{{count}} geplante Inspektion ist als überfällig markiert (je 12 Punkte, max. 24).",
overdueSchedulesRationale_other: "{{count}} geplante Inspektionen sind als überfällig markiert (je 12 Punkte, max. 24).",
overdueOpenJobsLabel_one: "Überfälliger offener Auftrag",
overdueOpenJobsLabel_other: "Überfällige offene Aufträge",
overdueOpenJobsInline_one: "überfälliger offener Auftrag",
overdueOpenJobsInline_other: "überfällige offene Aufträge",
overdueOpenJobsRationale_one: "{{count}} offener Auftrag hat ein Fälligkeitsdatum in der Vergangenheit (je 10 Punkte, max. 30).",
overdueOpenJobsRationale_other: "{{count}} offene Aufträge haben ein Fälligkeitsdatum in der Vergangenheit (je 10 Punkte, max. 30).",
highUrgencyJobsLabel_one: "Offener Auftrag mit hoher Dringlichkeit",
highUrgencyJobsLabel_other: "Offene Aufträge mit hoher Dringlichkeit",
highUrgencyJobsInline_one: "offener Auftrag mit hoher Dringlichkeit",
highUrgencyJobsInline_other: "offene Aufträge mit hoher Dringlichkeit",
highUrgencyJobsRationale_one: "{{count}} offener Auftrag ist auf hohe Dringlichkeit gesetzt (je 8 Punkte, max. 24).",
highUrgencyJobsRationale_other: "{{count}} offene Aufträge sind auf hohe Dringlichkeit gesetzt (je 8 Punkte, max. 24).",
pendingApprovalsLabel_one: "Ausstehende Berichtsabnahme",
pendingApprovalsLabel_other: "Ausstehende Berichtsabnahmen",
pendingApprovalsInline_one: "ausstehende Berichtsabnahme",
pendingApprovalsInline_other: "ausstehende Berichtsabnahmen",
pendingApprovalsRationale_one: "{{count}} geteilter Bericht wurde vom Empfänger noch nicht abgenommen (je 6 Punkte, max. 18).",
pendingApprovalsRationale_other: "{{count}} geteilte Berichte wurden vom Empfänger noch nicht abgenommen (je 6 Punkte, max. 18).",
recurringIssuesLabel_one: "Wiederkehrender Mangel",
recurringIssuesLabel_other: "Wiederkehrende Mängel",
recurringIssuesInline_one: "wiederkehrender Mangel",
recurringIssuesInline_other: "wiederkehrende Mängel",
recurringIssuesRationale_one: "{{count}} Mangel wurde bei mehr als einer der letzten {{window}} Inspektionen als nicht bestanden erfasst — die vorherige Reparatur hält nicht (je 6 Punkte, max. 18).",
recurringIssuesRationale_other: "{{count}} Mängel wurden bei mehr als einer der letzten {{window}} Inspektionen als nicht bestanden erfasst — die vorherige Reparatur hält nicht (je 6 Punkte, max. 18).",
inspectionFindingsLabel_one: "Nicht behobener Inspektionsbefund",
inspectionFindingsLabel_other: "Nicht behobene Inspektionsbefunde",
inspectionFindingsInline_one: "nicht behobener Inspektionsbefund",
inspectionFindingsInline_other: "nicht behobene Inspektionsbefunde",
inspectionFindingsRationale_one: "Die letzte abgeschlossene Inspektion enthält {{count}} nicht bestandenen oder reparaturbedürftigen Prüfpunkt (je 4 Punkte, max. 20).",
inspectionFindingsRationale_other: "Die letzte abgeschlossene Inspektion enthält {{count}} nicht bestandene oder reparaturbedürftige Prüfpunkte (je 4 Punkte, max. 20).",
noDocumentsLabel: "Keine Dokumente hinterlegt",
noDocumentsInline: "keine Dokumente hinterlegt",
noDocumentsRationale: "Mit dieser Anlage sind keine Zertifikate, Garantien oder Compliance-Dateien verknüpft. Auditoren erwarten in der Regel hinterlegte Nachweise.",
noCompletedInspectionLabel: "Keine abgeschlossene Basisinspektion",
noCompletedInspectionInline: "keine abgeschlossene Basisinspektion",
noCompletedInspectionRationale: "Es gibt noch keine abgeschlossene oder genehmigte Inspektion, daher lässt sich die Compliance nicht anhand von Daten aus dem Feld prüfen.",
staleInspectionLabel: "Letzte Inspektion vor über 90 Tagen",
staleInspectionInline: "letzte Inspektion vor über 90 Tagen",
staleInspectionRationale_one: "Die letzte abgeschlossene Inspektion liegt {{count}} Tag zurück. Ältere Nachweise erhöhen die Unsicherheit bei Audits.",
staleInspectionRationale_other: "Die letzte abgeschlossene Inspektion liegt {{count}} Tage zurück. Ältere Nachweise erhöhen die Unsicherheit bei Audits.",
recentInspectionsLabel: "Aktuelle Inspektionstätigkeit",
recentInspectionsInline: "aktuelle Inspektionstätigkeit",
recentInspectionsRationale_one: "{{count}} Inspektion wurde in den letzten 30 Tagen abgeschlossen, ohne überfällige Inspektionspläne oder Aufträge — ein positives Zeichen.",
recentInspectionsRationale_other: "{{count}} Inspektionen wurden in den letzten 30 Tagen abgeschlossen, ohne überfällige Inspektionspläne oder Aufträge — ein positives Zeichen.",
cleanWorkQueueLabel: "Keine offene Arbeit aus der letzten Inspektion",
cleanWorkQueueInline: "keine offene Arbeit aus der letzten Inspektion",
cleanWorkQueueRationale: "Zur letzten abgeschlossenen Inspektion gibt es keine offenen Aufträge und keine nicht behobenen Befunde.",
},
model: {
placeTypeLabel: "Art des Orts",
placeTypeHint: "Ein Gebäude, eine Etage, ein Raum oder ein anderer Bereich. Eigene Ortsarten erscheinen ebenfalls hier.",
customTypeLabel: "Anlagentyp",
customTypeNone: "Keiner",
vehicleNoParent: "Ein Fahrzeug befindet sich nicht in einer anderen Anlage. Es hat stattdessen einen Heimatstandort.",
sitsInLabel: "Befindet sich in",
sitsInHint: "Der Ort, das Fahrzeug oder die Anlage, in der sich dies befindet.",
sitsInHintPlace: "Der Ort, zu dem dieser Ort gehört, etwa die Etage eines Raums.",
sitsInA11yChange: "Befindet sich in {{name}}. Ändern",
sitsInA11yPick: "Wählen, wo sich dies befindet",
sitsInNone: "In nichts enthalten",
sitsInClear: "Herausnehmen",
sitsInPickerTitle: "Wo befindet es sich?",
sitsInSearch: "Orte und Anlagen suchen",
fieldsLabel: "Details zu {{type}}",
yes: "Ja",
no: "Nein",
datePlaceholder: "JJJJ-MM-TT",
fieldError: {
required: "Bitte ausfüllen",
number: "Eine Zahl eingeben",
date: "Ein Datum als JJJJ-MM-TT eingeben",
choice: "Eine der Optionen wählen",
},
fieldsIncompleteTitle: "Einige Angaben fehlen",
fieldsIncompleteBody: "Füllen Sie die markierten Angaben aus und speichern Sie erneut.",
placementFailedTitle: "Verschieben nicht möglich",
placementFailedBody: "Die Anlage wurde gespeichert, aber ihr Ort hat sich nicht geändert. Versuchen Sie es in der Anlage erneut.",
placementError: {
vehicle: "Ein Fahrzeug befindet sich nicht in einer anderen Anlage. Es hat stattdessen einen Heimatstandort.",
placeInPlace: "Ein Ort kann sich nur in einem anderen Ort befinden.",
alreadyPlaced: "Diese Anlage befindet sich bereits woanders. Verschieben Sie sie stattdessen.",
},
zonesLabel: "Zonen",
zonesHint: "Gruppen quer über Orte, etwa ein Brandabschnitt oder eine Reinigungszone. Mit Kommas trennen. Gruppenregeln und Rundgänge können nach Zone auswählen.",
zonesPlaceholder: "Brandabschnitt 2, Nordflügel",
placeTypes: {
property: "Immobilie",
building: "Gebäude",
wing: "Flügel",
floor: "Etage",
room: "Raum",
unit: "Einheit",
ward: "Station",
data_hall: "Datenhalle",
rack: "Rack",
plant_room: "Technikraum",
car_park: "Parkplatz",
yard: "Hof",
grounds: "Gelände",
pool: "Schwimmbad",
gate: "Tor",
area: "Bereich",
},
card: {
title: "Wo es sich befindet",
homeTitle: "Heimatstandort",
noHomeSite: "Noch kein Heimatstandort",
notInside: "In keinem anderen Ort",
twoParents: "Dies befindet sich an zwei Orten: {{names}}. Behalten Sie einen.",
keepParent: "{{name}} behalten",
contains_one: "Enthält {{count}} Element",
contains_other: "Enthält {{count}} Elemente",
directlyInside_one: "Direkt darin ({{count}})",
directlyInside_other: "Direkt darin ({{count}})",
andMore_one: "und {{count}} weiteres",
andMore_other: "und {{count}} weitere",
addPlace: "Ort darin hinzufügen",
addEquipment: "Ausrüstung hier hinzufügen",
move: "Verschieben",
putInside: "Hineinlegen",
takeOut: "Herausnehmen",
placeReport: "Bericht f\u00fcr diesen Ort",
zones: "Zonen",
rollupPlaces_one: "{{count}} Ort",
rollupPlaces_other: "{{count}} Orte",
rollupEquipment_one: "{{count}} Gerät",
rollupEquipment_other: "{{count}} Geräte",
rollupVehicles_one: "{{count}} Fahrzeug",
rollupVehicles_other: "{{count}} Fahrzeuge",
rollupOther_one: "{{count}} Sonstiges",
rollupOther_other: "{{count}} Sonstige",
rollupAtRisk_one: "{{count}} mit hohem Risiko",
rollupAtRisk_other: "{{count}} mit hohem Risiko",
rollupDueVisits_one: "{{count}} Termin fällig",
rollupDueVisits_other: "{{count}} Termine fällig",
rollupOpenJobs_one: "{{count}} offener Auftrag",
rollupOpenJobs_other: "{{count}} offene Aufträge",
rollupSeeWork: "Alle Arbeit darin ansehen",
addMany: "Viele darin hinzufügen",
startRound: "Rundgang starten",
groupRule: "Gruppenregel hinzufügen",
},
},
bulk: {
buildingTitle: "Gebäude einrichten",
seriesTitle: "Viele auf einmal hinzufügen",
buildingAction: "Gebäude einrichten",
buildingActionA11y: "Gebäude an {{site}} einrichten",
buildingIntro: "Wählen Sie die Gebäudeart und die Größe. Sie sehen jeden Ort und was er Ihre Rechnung kostet, bevor etwas angelegt wird.",
seriesIntro: "Eine nummerierte Reihe von Orten oder Objekten in {{place}} hinzufügen.",
presetLabel: "Gebäudeart",
multiUseHint: "Gemischt genutzter Standort? Richten Sie jedes Gebäude einzeln ein, jedes mit seiner eigenen Art.",
siteLabel: "Standort",
siteSearch: "Standorte suchen",
noSite: "Standort wählen",
buildingNameLabel: "Gebäudename",
buildingNamePlaceholder: "Gebäude A",
buildingNameRequired: "Geben Sie dem Gebäude einen Namen",
defaultBuildingName: "Hauptgebäude",
floorsLabel: "Etagen",
firstFloorLabel: "Etagen beginnen bei",
spaceLabel: "Auf jeder Etage",
perFloorLabel: "Anzahl {{type}} pro Etage",
perSpaceLabel: "Anzahl {{inside}} in jedem {{type}}",
extrasLabel: "Zusätzlich anlegen",
sitePlacesLabel: "Gemeinsame Orte am Standort",
sitePlacesHint: "Diese liegen auf Standortebene, nicht im Gebäude. Es werden nur die gezeigt, die der Standort noch nicht hat.",
addTypesLabel: "Übliche Anlagentypen hinzufügen",
addTypesHint: "Fügt {{types}} mit ihren Angaben hinzu, falls Sie sie noch nicht haben.",
seriesKindLabel: "Was hinzufügen",
patternLabel: "Namensmuster",
patternHint: "# steht für die Nummer. ## füllt auf zwei Stellen auf, also ergibt Raum ## Raum 01, Raum 02.",
defaultItemPattern: "Objekt ##",
startLabel: "Beginnen bei",
countLabel: "Wie viele",
previewTitle: "Was angelegt wird",
quoteTitle_one: "{{count}} neue Anlage",
quoteTitle_other: "{{count}} neue Anlagen",
quoteBilled: "Jeder Ort und jedes Objekt ist eine abgerechnete Anlage.",
quoteNow_one: "Sie haben jetzt {{count}} Anlage.",
quoteNow_other: "Sie haben jetzt {{count}} Anlagen.",
quoteAfter: "Sie haben dann {{after}} Anlagen.",
quoteAfterLimit: "Sie haben dann {{after}} der {{limit}} Anlagen, die Ihr Tarif erlaubt.",
quotePrice: "Ihre monatlichen Kosten steigen von {{before}} auf {{after}}.",
quoteOverLimit: "Das ist mehr, als Ihr Tarif erlaubt ({{limit}} Anlagen). Ändern Sie zuerst den Tarif oder legen Sie weniger an.",
quoteNeedsPlan: "Wählen Sie einen Tarif, bevor Sie weitere Anlagen hinzufügen.",
tooMany: "Höchstens {{max}} auf einmal. Legen Sie weniger an oder teilen Sie es auf.",
createButton_one: "{{count}} Anlage anlegen",
createButton_other: "{{count}} Anlagen anlegen",
created_one: "{{count}} Anlage angelegt",
created_other: "{{count}} Anlagen angelegt",
failedTitle: "Anlegen nicht möglich",
failedBody: "Es wurde nichts angelegt. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
names: {
groundFloor: "Erdgeschoss",
floor: "Etage {{n}}",
space: {
room: "Raum {{code}}",
ward: "Station {{code}}",
data_hall: "Datenhalle {{n}}",
gate: "Flugsteig {{code}}",
unit: "Einheit {{code}}",
area: "Bereich {{code}}",
},
inside: {
room: "Raum {{parent}}-{{n}}",
rack: "Serverschrank {{parent}}-{{n}}",
},
},
},
presets: {
names: {
office_block: "Bürogebäude",
hotel: "Hotel",
hospital: "Krankenhaus",
data_centre: "Rechenzentrum",
airport: "Flughafen",
shopping_centre: "Einkaufszentrum",
school: "Schule",
warehouse: "Lager",
custom: "Etwas anderes",
},
descriptions: {
office_block: "Büroetagen mit Empfang und Technikraum.",
hotel: "Gästezimmer auf jeder Etage, Empfang, Restaurant, Fitnessraum, Pools und Technikraum.",
hospital: "Stationen auf jeder Etage mit Zimmern, Empfang und Technikraum.",
data_centre: "Datenhallen mit Racks, Technikräume, ein Hof und ein Tor.",
airport: "Gates auf jeder Etage, Check-in, Gepäckhalle und Parkplatz.",
shopping_centre: "Ladeneinheiten auf jeder Etage, Food Court und Parkplatz.",
school: "Klassenräume auf jeder Etage, eine Aula, Gelände und Parkplatz.",
warehouse: "Lagerbereiche, ein Büro, ein Hof und ein Tor.",
custom: "Nur Etagen und Räume. Eigene Ortsarten können Sie später hinzufügen.",
},
extras: {
reception: "Empfang",
restaurant: "Restaurant",
gym: "Fitnessraum",
pool: "Pool",
plant_room: "Technikraum",
check_in: "Check-in",
baggage_hall: "Gepäckhalle",
food_court: "Food Court",
hall: "Aula",
office: "Büro",
car_park: "Parkplatz",
grounds: "Gelände",
yard: "Hof",
gate: "Tor",
},
types: {
guest_room: "Gästezimmer",
fire_door: "Brandschutztür",
lift: "Aufzug",
escalator: "Rolltreppe",
air_handler: "Lüftungsgerät",
chiller: "Kältemaschine",
boiler: "Heizkessel",
generator: "Notstromaggregat",
ups: "USV",
crac_unit: "Präzisionsklimagerät",
pdu: "PDU",
infusion_pump: "Infusionspumpe",
medical_gas_outlet: "Medizinische Gasentnahmestelle",
baggage_belt: "Gepäckband",
jet_bridge: "Fluggastbrücke",
dock_door: "Verladetor",
racking: "Regalanlage",
},
fields: {
beds: "Betten",
accessible: "Barrierefrei",
fireRating: "Feuerwiderstand",
selfClosing: "Selbstschließend",
capacityKg: "Tragkraft (kg)",
floorsServed: "Bediente Etagen",
riseM: "Förderhöhe (m)",
airflow: "Luftmenge (m³/s)",
filterSize: "Filtergröße",
refrigerant: "Kältemittel",
capacityKw: "Leistung (kW)",
fuel: "Brennstoff",
outputKw: "Ausgangsleistung (kW)",
ratingKva: "Nennleistung (kVA)",
batteryDate: "Batterie eingebaut am",
ratingA: "Nennstrom (A)",
phase: "Phase",
serialNumber: "Seriennummer",
nextCalibration: "Nächste Kalibrierung",
gas: "Gas",
lengthM: "Länge (m)",
leveller: "Überladebrücke",
bays: "Felder",
loadRatingKg: "Traglast (kg)",
},
},
  valueLife: {
    title: "Wert und Lebensdauer (optional)",
    hint: "Asset 360 nutzt dies, um Lebensdauer, Wert und Reparaturkosten im Vergleich zum Ersatz zu zeigen.",
    installedOn: "Eingebaut am",
    installedOnPlaceholder: "JJJJ-MM-TT",
    expectedLife: "Erwartete Lebensdauer in Jahren",
    expectedLifePlaceholder: "Zum Beispiel 15",
    purchaseCost: "Anschaffungskosten",
    replacementCost: "Ersatzkosten",
    replacementCostHelper: "Was ein Ersatz heute kosten würde.",
    currency: "Währung",
    currencyPlaceholder: "Zum Beispiel EUR",
    invalidTitle: "Wert und Lebensdauer prüfen",
    invalidBody: "Einige Angaben zu Wert und Lebensdauer sind ungültig. Korrigieren oder leeren Sie die markierten Felder.",
    saveFailedTitle: "Wert und Lebensdauer nicht gespeichert",
    saveFailedBody: "Der Rest der Anlage wurde gespeichert. Speichern Sie Wert und Lebensdauer erneut.",
    error: {
      installedOn: "Verwenden Sie ein Datum wie 2019-06-30.",
      expectedLifeYears: "Geben Sie ganze Jahre von 1 bis 200 ein.",
      purchaseCost: "Geben Sie einen Betrag ein, z. B. 1250 oder 1250.50.",
      replacementCost: "Geben Sie einen Betrag ein, z. B. 1250 oder 1250.50.",
      currency: "Verwenden Sie einen Code aus drei Buchstaben, z. B. EUR.",
    },
  },
  report360Charts: {
    other: "Sonstige",
    dataQualityA11y: "Datenqualität {{score}} von 100, {{band}}",
    measureA11y: "{{label}}: {{score}} von 100",
    notAvailable: "nicht verfügbar",
    trendEmptyA11y: "{{label}}: noch keine gespeicherten Werte.",
    trendEmpty: "Noch keine täglichen Werte gespeichert. Sie kommen Nacht für Nacht hinzu.",
  },
  report360,
};
